<template>
<div>
    <!-- Global snackbar for notifications -->
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      top
      centered
      :timeout="5000"
    >
      {{ snackbar.text }}
    </v-snackbar>
  <v-card flat class="mb-2 text-center overflow-x-hidden overflow-y-auto">
    <v-card-title v-if="isDesktop" class="text-h4 pb-0 font-weight-black d-flex justify-center">
      <v-btn class="text-h4" style="text-transform: none;"  text href="https://ibookrestaurant.it" target="_blank" rel="noopener noreferrer">iBookrestaurant <sup style="font-size: 50%">&reg;</sup></v-btn>
    </v-card-title>
    <v-card-text
      class="text-subtitle-1 py-1"
      v-if="reservationCountForBooking > (settings.options.minReservationToShow / 1 || 0)"
    >
      <v-icon color="error">mdi-fire</v-icon>
      {{ reservationCountForBooking }} {{ $t(page + '.Reservations today') }}.
    </v-card-text>
    <v-stepper v-model="stepper" alt-labels>
      <v-stepper-header class="pt-1" v-if="stepper>1">

        <!-- Step 2: Date -->
        <v-stepper-step
          :complete="stepper > 2"
          :editable="stepper > 2 && !successfulBooking"
          step="2"
          class="px-1"
        >
          <div class="text-center" @click="resetForm(2,stepper)">
            <v-icon :class="booking.date?'black--text':''">mdi-calendar</v-icon>
            <div v-if="booking.date" class="text-caption">
              {{formatDate(booking.date,'wdM').replace(/ /g,'&nbsp;')}}
            </div>
          </div>
        </v-stepper-step>
        <v-divider></v-divider>

        <!-- Step 3: Covers -->
        <v-stepper-step
          :complete="stepper > 3"
          :editable="stepper > 3 && !successfulBooking"
          step="3"
          class="px-1"
        >
          <div class="text-center" @click="resetForm(3,stepper)">
            <v-icon :class="booking.covers?'black--text':''">mdi-account-group</v-icon>
            <template v-if="booking.covers">
              <template v-if="maxBookableChildrenForDate==='0'">
                <div class="text-caption">{{booking.covers}} 
              </template>
              <template v-else>
                <p class="text-caption mb-0">{{booking.covers}}+{{booking.children||0}}</p>
             </template>
            </template>
          </div>
        </v-stepper-step>
        <v-divider></v-divider>

        <!-- Step 6: Location (indoor/outdoor) -->
        <v-stepper-step
          :complete="stepper > 6"
          :editable="stepper > 6 && !successfulBooking"
          step="6"
          class="px-1"
        >
          <div class="text-center">
            <v-icon :class="booking.locationId ? 'black--text' : ''">
              mdi-table-furniture
            </v-icon>
            <div class="text-caption">
              {{booking.locationId && locations && locations.find(l=>l.locationId==booking.locationId)
                ? $t(page+'.'+locations.find(l=>l.locationId==booking.locationId).name)
                : ''}}
            </div>
          </div>
        </v-stepper-step>
        <v-divider></v-divider>


        <!-- Step 7: Time slot -->
        <template v-if="(requests&&requests.length)||(foodStyles&&foodStyles.length)">
          <v-stepper-step
            :complete="stepper > 7"
            :editable="stepper > 7 && !successfulBooking"
            step="7"
            class="px-1"
          >
            <div class="text-center" @click="!successfulBooking && (stepper=6)">
              <v-icon :class="booking.slotId ? (booking.waiting? 'warning--text' : 'black--text') : ''">
                {{booking.waiting ? 'mdi-timer-sand' : 'mdi-clock-outline'}}
              </v-icon>
              <div class="text-caption" :class="booking.waiting?'warning--text':''">{{booking.time}}</div>
            </div>
          </v-stepper-step>
        </template>
        <v-divider></v-divider>

        <!-- Step 8: Contact details -->
        <v-stepper-step
          :complete="stepper > 8"
          :editable="stepper > 8 && !successfulBooking"
          step="8"
          class="px-1"
        >
          <div class="text-center">
            <v-icon class="is_ValidPhone(booking.phone,booking.countryCode)===true?'green--text':''">mdi-whatsapp</v-icon>
            <div v-if="stepper>=8&&stepper<30" class="text-caption " :class="is_ValidPhone(booking.phone,booking.countryCode)===true?'black--text':''">
              {{booking.phone&&booking.phone.toString().replace(/\s/g,'').replace(/(\d{3})(\d{2,3})(\d{2})(\d{2})/, '$1&nbsp;$2&nbsp;$3&nbsp;$4')}}
            </div>
          </div>
        </v-stepper-step>

      </v-stepper-header>
      <v-stepper-items class="mt-2 px-0">

        
        <!-- STEP 2: DATE PICKER                             -->
        
        <v-stepper-content step="2" class="pa-0">
          <v-card flat class="mb-0 text-center" :style="'height:'+(wHeight-190)+'px;overflow-y:auto'">
            <template v-if="!bookableDays">
              <div class="d-flex justify-center align-center" :style="'height:'+(wHeight-246)+'px'">
                <v-progress-circular indeterminate size="200" width="14" color="black"></v-progress-circular>
              </div>
            </template>
            <template v-else>
              <v-date-picker
                v-if="bookableDays"
                :class="['custom-sq-picker', currentBooking ? 'booking-date-amber' : '']"
                v-model="booking.date"
                :color="settings.options.color"
                header-color=""
                :weekday-format="formatDate(date,'w').toUpperCase()"
                :header-format="formatDate(date,'NY').toUpperCase()"
                :locale="locale"
                :disabled="Boolean(expired && expired.expired === 1)"
                no-title
                full-width
                first-day-of-week=1
                :min="bookableDays[0].date"
                :max="bookableDays[bookableDays.length - 1].date"
                :allowed-dates="allowedDates"
                @click:date="handleDateClick"
                style="min-height:380px;overflow-y:auto;overflow-x:hidden"
              >            
              </v-date-picker>
              <div v-if="bookableDays && bookableDays[0].date == new Date().toISOString().split('T')[0]&&bookableDays[0].message">
                <div class="text-subtitle-1 mt-1 font-weight-bold" :class="bookableDays[0].message==='DAY_CLOSED'?'error--text':'warning--text'">
                  <div v-if="bookableDays[0].from">{{bookableDays[0].message}}
                    <br />{{$t(page+'.from')}} {{formatDate(bookableDays[0].from,'dN')}} {{$t(page+'.TO')}} {{formatDate(bookableDays[0].to,'dN')}}</div>
                  <div v-else>{{$t(page+'.'+bookableDays[0].message)}}</div>
                </div>
              </div>  
              <v-card-text class="mt-0" v-if="settings&&settings.options.DBMessage&&settings.options.DBMessageEnabled&&bookableDays[0].date<=settings.options.DBMessageEnabled.substring(0,10)">
                <div class="text-center text-subtitle-1">
                  {{settings.options.DBMessage}}
                </div>
              </v-card-text>           
            </template>
          </v-card>
          <v-card>
        </v-stepper-content>

        
        <!-- STEP 3: COVERS + HIGHCHAIRS                    -->
        
        <v-stepper-content step="3">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-212)+'px'">

            <!-- Adults -->
            <v-card flat class="px-3 mb-2">
              <v-card-title class="py-0 text-subtitle-1">
                <v-icon class="mr-2 black--text">mdi-account-multiple</v-icon>
                {{$t(page+'.How many People')}}?
              </v-card-title>
              <!-- v-btn-toggle: active = selected, amber = suggested (from currentBooking), default = unselected -->
              <v-btn-toggle
                v-model="booking.covers"
                active-class=""
                class="d-flex flex-wrap justify-center transparent-bg w-100 pa-1"
                @change="booking.slotId=null; handleCoversChange(booking.covers)"
              > <div>
                <v-btn
                  v-for="c in Array.from({length:settings.options.maxBookableCovers/1}, (_,i) => i+1)"
                  :key="'c-'+c"
                  outlined
                  :value="c"
                  :disabled="!booking.date||!bookableDays.find(d=>d.date===booking.date)||!bookableDays.find(d=>d.date===booking.date).isDAY_OPEN"
                  :class="['text-subtitle-1 ma-1',
                    booking.covers===c
                      ? (currentBooking ? 'amber darken-2 white--text' : 'black white--text')
                      : (currentBooking && currentBooking.covers===c ? 'amber lighten-4' : '')
                  ]"
                  style="width:calc(20% - 8px); border-color:rgba(0,0,0,0.12)"
                  @click="maxBookableChildrenForDate==='0'?booking.children=0:null"
                >{{c}}</v-btn>
                </div>
              </v-btn-toggle>
            </v-card>
            <!-- Highchairs -->
            <v-card flat class="pa-3 mb-2">
              <template>
                <v-card-title class="py-0 text-subtitle-1">
                  <v-icon class="mr-2 black--text">mdi-chair-school</v-icon>
                  <template v-if="childrenQuestion === true || currentBooking">
                    {{$t(page+'.How many')}}?
                  </template>
                  <template v-else>
                    {{$t(page+'.Children requiring High Chairs')}}?
                  </template>
                </v-card-title>
                <template v-if="maxBookableChildrenForDate!=='0'">
                    <!-- Step A: Yes / No question (shown until user answers) -->
                    <template v-if="childrenQuestion === null && !currentBooking">
                      <div class="d-flex justify-center mt-3 mb-1 gap-2">
                        <v-btn
                          outlined large
                          class="mx-2 px-6 text-subtitle-1"
                          style="min-width:120px; border-color:rgba(0,0,0,0.18)"
                          :disabled="!booking.date || !bookableDays.find(d=>d.date===booking.date) || !bookableDays.find(d=>d.date===booking.date).isDAY_OPEN"
                          @click="childrenQuestion = false; booking.children = 0; booking.slotId = null; booking.covers && booking.children != null ? changeStepper(3, null) : ''"
                        >
                          <v-icon left>mdi-close-circle-outline</v-icon>
                          {{ $t(page+'.No') }}
                        </v-btn>
                        <v-btn
                          outlined large
                          class="mx-2 px-6 text-subtitle-1"
                          style="min-width:120px; border-color:rgba(0,0,0,0.18)"
                          :disabled="!booking.date || !bookableDays.find(d=>d.date===booking.date) || !bookableDays.find(d=>d.date===booking.date).isDAY_OPEN"
                          @click="childrenQuestion = true; booking.children = null"
                        >
                          <v-icon left>mdi-check-circle-outline</v-icon>
                          {{ $t(page+'.Yes') }}
                        </v-btn>
                      </div>
                    </template>

                    <!-- Step B: count buttons (1-3 only, 0 excluded) shown after user clicked Yes -->
                    <template v-else-if="childrenQuestion === true||currentBooking">
                      <v-btn-toggle
                        v-model="booking.children"
                        active-class=""
                        class="d-flex flex-wrap justify-center transparent-bg w-100 pa-1"
                        @change="booking.slotId=null; booking.covers && booking.children != null ? changeStepper(3, null) : ''"
                      >
                        <div style="width:100%">
                          <v-btn
                            v-for="c in Array.from({length:maxBookableChildrenForDate/1+1}, (_,i) => i)"
                            :key="'ch-'+c"
                            outlined
                            :value="c"
                            :disabled="!booking.date || !bookableDays.find(d=>d.date===booking.date) || !bookableDays.find(d=>d.date===booking.date).isDAY_OPEN"
                            :class="['text-subtitle-1 ma-1',
                              booking.children===c
                                ? (currentBooking ? 'amber darken-2 white--text' : 'black white--text')
                                : (currentBooking && currentBooking.children===c ? 'amber lighten-4' : '')
                            ]"
                            style="width:calc(33% - 8px); border-color:rgba(0,0,0,0.12)"
                          >{{c}}</v-btn>
                        </div>
                      </v-btn-toggle>

                    </template> 
                </template>
                <template v-else>
                  <div class="text-subtitle-1 text-center mt-3 mb-0">
                    {{$t(page+'.'+settings.options.maxChildrenZeroText)}}
                  </div>
                </template>              
              </template>
            </v-card>
            <v-card flat class="px-3 mb-2">
              <!-- "N+" stays outside the toggle — opens dialog, not a real selection -->
              <div class="d-flex justify-center px-1 pb-1 mt-2">
                <v-btn
                  outlined
                  block
                  class="text-subtitle-1 ma-1 pa-2"
                  style="width:calc(25% - 8px); border-color:rgba(0,0,0,0.12); height:48px"
                  :disabled="!booking.date||!bookableDays.find(d=>d.date===booking.date)||!bookableDays.find(d=>d.date===booking.date).isDAY_OPEN"
                  @click="handleCoversChange(settings.options.maxBookableCovers/1+1)"
                >
                {{$t(page+'.Reservation beyond')}} {{settings.options.maxBookableCovers/1}} {{$t(page+'.Covers')}}
                </v-btn>
              </div>              
            </v-card>
          </div>
        </v-stepper-content>

        <!-- STEP 6: LOCATION (if multi) + SLOTS BY MEAL    -->
        
        <v-stepper-content step="6">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-212)+'px'">
              <!-- Location picker (only when multi-location) -->
              <template v-if="locations && locations.filter(x=>(booking.date>=x.dateFrom&&booking.date<=x.dateTo)||!booking.date).length>1">
                <v-card flat class="pa-2 mb-2">
                  <v-card-title class="justify-center py-1 text-subtitle-1">
                    <v-icon class="mr-2 black--text">mdi-map-marker</v-icon>
                    {{$t(page+'.Select Area')}}
                  </v-card-title>
                  <div class="d-flex flex-wrap justify-center">
                    <v-btn-toggle
                      @change="changeLocation"
                      v-model="booking.locationId"
                      class="d-flex flex-wrap transparent-bg justify-center"
                      style="width:100%"
                    >
                      <v-btn
                        v-for="(l,l2) in locations.filter(x=>(booking.date>=x.dateFrom&&booking.date<=x.dateTo)||!booking.date)"
                        :key="l2"
                        small
                        block
                        outlined
                        :disabled="l.hasNoActiveActive"
                        :loading="loading"
                        :class="['text-subtitle-1 ma-1 mb-3',
                              booking.locationId===l.locationId
                                ? (currentBooking ? 'amber darken-2 white--text' : 'black white--text')
                                : (currentBooking && currentBooking.locationId===l.locationId ? 'amber lighten-4' : '')
                            ]"
                        :value="l.locationId"
                        height="60"
                        style="flex: 1 0 auto;border-left-width: 1px;"
                      >
                        <span class="d-flex flex-column align-center" style="width:100%">
                          <div>
                            {{$t(page+'.'+l.nameDB)}}
                          </div>
                          <div
                            v-if="l.hasNoActiveTable==1"
                            class="white--text px-2 mt-1 red"
                            style="font-size:0.65rem!important;padding:2px 8px;border-radius:10px; position: absolute;top: 27px;"
                            v-html="$t(page+'.Area Closed')"
                          >
                          </div>
                          <div
                            v-else-if="l.hasNoTableAvailable==1"
                            class="white--text px-2 mt-1 error"
                            style="font-size:0.65rem!important;padding:2px 8px;border-radius:10px; position: absolute;top: 27px;"
                            v-html="$t(page+'.Fully Booked')"
                          >
                          </div>                          
                          <div
                            v-else
                            class="white--text px-2 mt-1 success"
                            style="font-size:0.65rem!important;padding:2px 8px;border-radius:10px; position: absolute;top: 27px;"
                            v-html="$t(page+'.Available')"
                          >
                          </div>                          
                        </span>
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </v-card>
              </template>
            <!-- Loading spinner -->
            <!--
            <div v-if="loading" class="d-flex justify-center align-center py-10">
              <v-progress-circular indeterminate size="181" width="20" color="black"></v-progress-circular>
            </div>
            -->
            
            <div v-if="loading && !freeTables" class="d-flex justify-center align-center py-10">
              <v-progress-circular indeterminate size="181" width="20" color="black"></v-progress-circular>
            </div>
            <template v-else-if="freeTables && freeTables.length">
              <!-- Location picker (only when multi-location) -->
              <transition name="slot-reveal">
                <div v-if="booking.locationId && freeTables">
                  <v-card-title class="justify-center py-0 text-subtitle-1">
                    <v-icon class="mr-2 black--text">mdi-clock</v-icon>
                    {{$t(page+'.Select Time')}}
                  </v-card-title>
                  <!-- Slots grouped by meal -->
                  <v-btn-toggle
                    @change="goToNextAfterSlot()"
                    v-model="booking.slotId"
                    :active-class="(currentBooking ? 'amber darken-2' : 'black')+' white--text'"
                    class="d-flex flex-wrap justify-center transparent-bg"
                  >
                    <v-row class="ma-0 pa-0 w-100">
                      <!--<template v-for="(ft, f1) in freeTables">-->
                        <template v-for="(ft, f1) in freeTables.filter(f => meals.some(m => m.mealId === f.mealId))">
                        <!-- Meal section header: show when meal changes -->
                        <v-col
                          cols="12"
                          class="px-2 pt-0 pb-1"
                          :key="'header-'+f1"
                          v-if="f1===0 || freeTables[f1-1].mealId !== ft.mealId"
                        >
                          <div class="text-subtitle-1 font-weight-bold grey--text text--darken-2 text-left">
                            <v-col cols="6" class="px-0 mx-0 py-0 float-left">
                              {{$t(page+'.'+ft.mealName)}}
                            </v-col>
                          </div>
                        </v-col>
                          
                        <!-- Slot button (2 per row) -->
                        <v-col class="px-1 py-1" cols="6" lg="4" :key="'slot-'+f1">
                          <v-btn
                            outlined
                            block
                            class="text-subtitle-1 slot-btn px-1"
                            :class="['text-subtitle-1 slot-btn ma-1 px-4', currentBooking && currentBooking.slotId===ft.slotId && booking.slotId!==ft.slotId ? 'amber lighten-4' : '']"
                            :value="ft.slotId"
                            height="60"
                            :loading="loading"
                            :disabled="slotState(ft).disabled"
                            @click="processSlot(ft)"
                          >
                            <span class="d-flex flex-column align-center mt-n4" style="width:100%">
                              <span v-if="ft.bonus" style="line-height:1;min-height:12px;position:absolute;left:0">
                                <v-icon class="success--text" @click.stop="showMealInfo(ft,'bonus')"  >mdi-glass-flute</v-icon>
                              </span>
                              <span class="caption" style="font-size:0.60rem!important;line-height:1;min-height:12px">
                                {{ft.slotMessage?ft.slotMessage:''}}
                              </span>
                              <span v-if="ft.prepayment&&ft.prepayment>0" style="line-height:1;min-height:12px;position:absolute;right:-10px">
                                <v-icon class="info--text" @click.stop="showMealInfo(ft,'prepayment')" >mdi-currency-eur</v-icon>
                              </span>
                              <span v-if="isDev" class="caption grey--text" style="line-height:1;min-height:12px;position:absolute;right:0;bottom:-12px">
                                {{ft.manualConfirmation}}|{{ft.notCompliant}}
                              </span>
                              <span v-else class="caption grey--text" style="line-height:1;min-height:12px;position:absolute;right:-10px;bottom:-18px">
                                <template v-if="ft.covers>0&&ft._booked_in_Slot>ft.covers*settings.options.rushHoursThreshold/100">
                                  <v-icon class="error--text" @click.stop="showMealInfo(ft,'rushhours')" >mdi-fire</v-icon>
                                </template>
                              </span>
                              <span v-if="ft.showBookingDurationInSlot&&ft.duration<(settings.options.defaultMealDuration/1)" style="line-height:1;min-height:12px;position:absolute;left:0;top:15px">
                                <v-icon class="warning--text" @click.stop="showMealInfo(ft,'duration')"  >mdi-clock-fast</v-icon>
                              </span>                          
                              <span class="text-body-1 font-weight-black">{{ft.name}}</span>
                              <span
                                class="white--text px-2 mt-1"
                                style="font-size:0.65rem!important;padding:2px 8px;border-radius:10px; position: absolute;top: 27px;"
                                :class="slotState(ft).badgeClass"
                                v-html="slotState(ft).label"
                              >
                              </span>

                            </span>
                          </v-btn>
                        </v-col>

                      </template>
                    </v-row>
                  </v-btn-toggle>
                </div>
                <!--
                <div v-else class="d-flex justify-center align-center py-10">
                  <v-progress-circular indeterminate size="180" width="20" color="black"></v-progress-circular>
                </div>
                -->
              </transition>
            </template>
            <!-- No slots available -->
            <div v-else-if="tryToGetFreeSlots && !freeTables">
              <v-alert dense type="warning" icon="mdi-information" class="ma-3">
                {{$t(page+'.No slots available for today at')}}{{meals&&booking.mealId&&meals.find(m=>m.mealId==booking.mealId)?' '+$t(page+'.'+meals.find(m=>m.mealId==booking.mealId).name):''}}{{': '}}{{$t(page+'.Select another day')}}
              </v-alert>
            </div>
            <div v-else></div>

          </div>
        </v-stepper-content>
 
        <!-- STEP 7: REQUESTS / FOOD STYLES (skip if empty) -->

        <v-stepper-content step="7">
          <div :style="'display:flex;flex-direction:column;height:'+(wHeight-236)+'px'">
          <div class="overflow-y-auto flex-grow-1">

            <!-- Food styles -->
            <div class="mb-5" v-if="foodStyles && foodStyles.length">
              <div class="section-label mb-2">
                <v-icon class="mr-1" size="18">mdi-food</v-icon>
                {{$t(page+'.Dietary Preferences')}}
              </div>

              <div class="tile-grid">
                <div
                  v-for="(r,i) in foodStyles"
                  :key="'fs-'+i"
                  class="option-tile py-1"
                  :class="{
                    'option-tile--selected': booking.foodStyles.indexOf(r.requestId) !== -1,
                    'option-tile--disabled': !booking.covers,
                    'option-tile--prev': currentBooking && currentBooking.foodStyles && currentBooking.foodStyles.indexOf(r.requestId) !== -1 && booking.foodStyles.indexOf(r.requestId) === -1
                  }"
                  @click="toggleOption('foodStyles', r.requestId)"
                >
                  <v-icon
                    class="option-tile__check"
                    v-if="booking.foodStyles.indexOf(r.requestId) !== -1"
                    size="16"
                    color="white"
                  >mdi-check</v-icon>

                  <v-icon
                    class="option-tile__icon"
                    :color="booking.foodStyles.indexOf(r.requestId) !== -1 ? 'white' : 'black'"
                  >{{r.icon}}</v-icon>
                  <div class="option-tile__label" v-html="r.description"></div>
                </div>
              </div>
            </div>

            <!-- Requests -->
            <div class="mb-5" v-if="requests && requests.length">
              <div class="section-label mb-2">
                <v-icon class="mr-1" size="18">mdi-clipboard-list</v-icon>
                {{$t(page+'.Special Needs & Occasions')}}
              </div>

              <div class="tile-grid">
                <div
                  v-for="(r,i) in requests"
                  :key="'req-'+i"
                  class="option-tile py-1"
                  :class="{
                    'option-tile--selected': booking.requests.indexOf(r.requestId) !== -1,
                    'option-tile--disabled': !booking.covers,
                    'option-tile--prev': currentBooking && currentBooking.requests && currentBooking.requests.indexOf(r.requestId) !== -1 && booking.requests.indexOf(r.requestId) === -1
                  }"
                  @click="toggleOption('requests', r.requestId)"
                >
                  <v-icon
                    class="option-tile__check"
                    v-if="booking.requests.indexOf(r.requestId) !== -1"
                    size="16"
                    color="white"
                  >mdi-check</v-icon>

                  <v-icon
                    class="option-tile__icon"
                    :color="booking.requests.indexOf(r.requestId) !== -1 ? 'white' : 'black'"
                  >{{r.icon}}</v-icon>

                  <div class="option-tile__label" v-html="r.description"></div>
                </div>
              </div>
            </div>

            <!-- Remarks -->
            
            <div cols="12" class="py-1 px-1">
              <v-text-field
                prepend-inner-icon="mdi-comment"
                :color="settings.options.color"
                :label="$t(page+'.Special requests')"
                v-model="booking.remarks"
                name="remarks"
                autocomplete="off"
                outlined
                dense
                hide-details
                :hint="$t(page+'.Hints to make your visit unforgettable')"
              ></v-text-field>
            </div>

          </div>

          <!-- Continue button — pinned below scroll area -->
          <div class="text-center pt-2 pb-2">
            <v-btn
              outlined
              large
              block
              class="px-8 mt-2 mb-4"
              @click="stepper=8"
            >
              {{$t(page+'.Continue')}}
            </v-btn>
          </div>
          </div>
        </v-stepper-content>


        <!-- STEP 8: GUEST DETAILS                          -->
        
        <v-stepper-content step="8" class="px-2">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-212)+'px'">
            <v-card flat class="pa-0 mb-3">
              <v-card-text class="px-3 pt-2 pb-1">
                <v-row class="d-flex justify-center">

                  <!-- Country code -->
                  <v-col  class="py-1 px-1 pt-2" @click="(customer&&customer.validated||voxNumber) && (dialog_readonly_phone = true)">
                    <v-select
                      :color="settings.options.color"
                      dense
                      outlined
                      v-model="booking.countryCode"
                      :items="countries"
                      :label="$t(page+'.Country Code')"
                      hide-details
                      :readonly="customer&&customer.validated||voxNumber"
                      :item-text="item => item.name+'+'+item.value"
                    >
                      <template v-slot:item="slotProps">
                        <i :class="['mr-1','em',slotProps.item.flag]"></i>
                        {{slotProps.item.namel}} + {{slotProps.item.value}}
                      </template>
                      <template v-slot:selection="data">
                        <i :class="['mr-1','em',data.item.flag]"></i>
                        {{$vuetify.breakpoint.mdAndUp?data.item.namel+' + ':''}}{{data.item.value}}
                      </template>
                    </v-select>
                  </v-col>

                  <!-- Phone -->
                  <v-col  class="px-1 pt-2 pb-0" @click="(customer&&customer.validated||voxNumber) && (dialog_readonly_phone = true)">
                    <v-text-field
                      ref="phone"
                      prepend-inner-icon="mdi-whatsapp"
                      :color="currentBooking?'amber darken-2':success"
                      :label="$t(page+'.WhatsApp Number')"
                      v-model="booking.phone"
                      name="phone"
                      type="tel"
                      autocomplete="tel-national"
                      reverse
                      hide-spin-buttons
                      outlined
                      dense
                      required
                      :error="!booking.phone || is_ValidPhone(booking.phone,booking.countryCode) !== true"
                      :success="!!booking.phone && is_ValidPhone(booking.phone,booking.countryCode) === true"
                      :counter="mobilePhoneRegex&&mobilePhoneRegex.find(m=>m.countryCode==booking.countryCode)?mobilePhoneRegex.find(m=>m.countryCode==booking.countryCode).maxLength:false"
                      :counter-value="v => String(v||'').replace(/\s/g,'').length"
                      :hint="phoneRegexHints(booking.countryCode)"
                      persistent-hint
                      :rules="[is_ValidPhone(booking.phone,booking.countryCode)]"
                      :readonly="customer&&customer.validated||voxNumber"
                      v-mask="phoneMask(booking.countryCode)"
                    ></v-text-field>
                  </v-col>

                </v-row>
                <v-row>
                  <!-- OTP verification field (shown after WA OTP sent) -->
                  <template v-if="otpSent">
                    <v-col cols="6" class="pa-1">
                      <v-text-field
                        prepend-inner-icon="mdi-shield-key"
                        :color="settings.options.color"
                        :label="$t(page+'.Enter OTP')"
                        v-model="booking.otp"
                        type="tel"
                        inputmode="numeric"
                        hide-spin-buttons
                        outlined
                        dense
                        placeholder="000-000-000"
                        v-mask="'###-###-###'"
                        :maxlength="11"
                        :minlength="11"
                        :error="otpError || !booking.otp || booking.otp.length !== 11"
                        :success="!otpError && !!booking.otp && booking.otp.length === 11"
                        :hint="otpError ? $t(page+'.Invalid code, please try again') : $t(page+'.Check your WhatsApp')"
                        persistent-hint
                        :rules="[v => v && v.length === 11 || $t(page+'.OTP must be 9 digits')]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="5" class="pa-1 mt-n6 d-flex align-center">
                      <v-btn
                        class="px-2"
                        text color="black"
                        :disabled="otpResendCooldown > 0 || (booking.otp && booking.otp.length == 11)"
                        @click="sendOtpWA()"
                      >
                        <v-icon large class="mr-1">mdi-send</v-icon>
                        {{ otpResendCooldown > 0 ? otpResendCooldown : $t(page+'.Resend') }}
                      </v-btn>
                    </v-col>
                  </template>

                  <!-- OTP sending indicator -->
                  <v-col cols="12" class="pa-1 text-center" v-if="otpSending">
                    <v-progress-circular indeterminate size="20" width="2" color="black" class="mr-2"></v-progress-circular>
                    <span class="caption grey--text">{{$t(page+'.Sending WhatsApp Code')}}...</span>
                  </v-col>

                  <!-- First name -->
                  <v-col cols="6" class="pt-2 pb-1 px-1">
                    <v-text-field
                      prepend-inner-icon="mdi-account"
                      :color="currentBooking?'amber darken-2':success"
                      :label="$t(page+'.First Name')"
                      v-model="booking.firstName"
                      name="firstName"
                      autocomplete="off"
                      outlined
                      dense
                      :error="!booking.firstName"
                      :success="!!booking.firstName"
                      :readonly="booking.bookingId"
                      :hint="$t(page+'.First Name only')"
                      hide-details
                      ref="firstName"
                    ></v-text-field>
                  </v-col>

                  <!-- Last name -->
                  <v-col cols="6" class="pt-2 pb-1 px-1">
                    <v-text-field
                      prepend-inner-icon="mdi-account"
                      :color="currentBooking?'amber darken-2':success"
                      :label="$t(page+'.Last Name')"
                      v-model="booking.lastName"
                      name="lastName"
                      autocomplete="off"
                      outlined
                      dense
                      :error="!booking.lastName"
                      :success="!!booking.lastName"
                      :hint="$t(page+'.Last Name only')"
                      hide-details
                      ref="lastName"
                    ></v-text-field>
                  </v-col>

                  <!-- Birthdate (conditional) -->
                  <v-col :cols="settings.options.postalCodeRequested=='1'||settings.options.postalCodeRequired=='1'&&booking.countryCode==39?6:12" class="py-1 px-1" v-if="(settings.options.birthdateRequested=='1'||settings.options.birthdateRequired=='1')||settings.options.minAge&&!booking.birthdate&&!booking.bookingId">
                    <v-menu
                      ref="menuBirthdate"
                      v-model="menuBirthdate"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :error="settings.options.birthdateRequired=='1'&&!booking.birthdate"
                          :success="settings.options.birthdateRequired=='1'&&!!booking.birthdate"
                          :value="booking.birthdate ? booking.birthdate.substring(0,10).split('-').reverse().join('-') : ''"
                          :label="settings.options.birthdateRequired=='1'?$t(page+'.Birthdate')+' *':$t(page+'.Birthdate')"
                          prepend-inner-icon="mdi-calendar"
                          outlined
                          readonly
                          hide-details
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="birthdate"
                        no-title
                        first-day-of-week=1
                        :locale="locale"
                        v-model="booking.birthdate"
                        :color="settings.options.color"
                        :max="subtractYears(13)"
                        :min="subtractYears(99)"
                        @change="saveBirthdate"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <!-- Postal code (conditional) -->
                  <v-col :cols="settings.options.birthdateRequested=='1'||settings.options.birthdateRequired=='1'?6:12" class="py-1 px-1"
                    v-if="(settings.options.postalCodeRequested=='1'||settings.options.postalCodeRequired=='1')&&booking.countryCode==39"
                  >
                    <v-text-field
                      prepend-inner-icon="mdi-map-marker"
                      ref="postalCode"
                      :error="settings.options.postalCodeRequired=='1'&&(!booking.postalCode||String(booking.postalCode).length!=5)"
                      :success="settings.options.postalCodeRequired=='1'&&!!booking.postalCode&&String(booking.postalCode).length==5"
                      :label="settings.options.postalCodeRequired=='1'?$t(page+'.Postal Code')+' *':$t(page+'.Postal Code')"
                      v-model="booking.postalCode"
                      name="postalCode"
                      type="number"
                      dense
                      :disabled="booking.countryCode!=39"
                      hide-details
                      autocomplete="off"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <!-- Email (conditional) -->
                  <v-col cols="12" class="py-1 px-1" v-if="settings.options.emailRequested=='1'||settings.options.emailRequired=='1'&&!booking.bookingId">
                    <v-text-field
                      prepend-inner-icon="mdi-at"
                      :color="settings.options.emailRequired=='1'?'error':settings.options.color"
                      :label="settings.options.emailRequired=='1'?$t(page+'.Email')+' *':$t(page+'.Email')"
                      v-model="booking.email"
                      name="email"
                      autocomplete="off"
                      outlined
                      hide-details
                      dense
                      ref="email"
                      :hint="settings.options.emailRequired=='1'?$t(page+'.Mandatory'):$t(page+'.Optional')"
                    ></v-text-field>
                  </v-col>

                   <!-- Password (conditional) -->
                  <!--
                  <v-col cols="12" class="py-1 px-1">
                    <v-text-field
                      prepend-inner-icon="mdi-form-textbox-password"
                      :label="$t(page+'.Set up your password')"
                      v-model="booking.password"
                      name="password"
                      autocomplete="off"
                      outlined
                      hide-details
                      dense
                      :hint="$t(page+'.Helpful for recovering your reservation if you lose access')"
                    ></v-text-field>
                  </v-col>
                  -->
                </v-row>
                <v-row v-if="booking.slotId && freeTables && freeTables.find(ft => ft.slotId === booking.slotId) && freeTables.find(ft => ft.slotId === booking.slotId).showBookingDurationInSlot">
                  <v-col cols="12" class="py-2 px-1">
                    <v-alert dense text color="info" class="my-2 px-2">
                      {{ $t(page+'.We wish we could host everyone! For this reason, seating is limited to') }} 
                      <strong>{{ freeTables.find(ft => ft.slotId === booking.slotId).duration }}</strong> 
                      {{ $t(page+'.minutes') }}. {{$t(page+'.Thank you so much for understanding')}}! ❤️
                    </v-alert>
                    <v-alert v-if="(settings.options.maxDelayMinutes/1)>0" dense text color="info" class="my-2 px-2">
                      {{$t(page+'.To be fair to everyone, we will hold it for')}} {{settings.options.maxDelayMinutes}} {{$t(page+'.minutes past your booking time Please let us know if you are running late')}}!
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-2 px-1">
                    <div class="text-center py-5">
                      <v-btn
                        outlined
                        large
                        block
                        :disabled="!canProceedToConsent"
                        :loading="loading_book"
                        @click="checkBooking()"
                      >
                        {{ customer && customer.validated == 1 ? $t(page+'.Book Now') : $t(page+'.Continue') }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-2 px-1">
                  <v-carousel
                    v-if="advertisers && advertisers.length"
                    v-model="advertiserCarousel"
                    cycle
                    continuous
                    interval="3000"
                    hide-delimiters
                    :show-arrows="false"
                    :height="carouselHeight"
                  >
                    <v-carousel-item
                      v-for="(item, i) in advertisers"
                      :key="'fs-' + i"
                      :class="{ 'clickable-slide': isDesktop }"
                    >
                      <v-sheet :color="item.color" height="100%" @click.stop="openAdvertiser(item)">
                        <v-img
                          :src="`/static/users/pictures/advertisers/${item.logo}`"
                          contain
                          height="100%"
                        />
                      </v-sheet>
                    </v-carousel-item>
                  </v-carousel> 
                  <div class="text-caption">Vuoi pubblicizzare la tua azienda qui? <a href="https://wa.me/393208443389">Contattaci</a></div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>



          </div>
        </v-stepper-content>

        <!-- STEP 9: CONSENT + SUBMIT                      -->
        
        <v-stepper-content step="9">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-213)+'px'">

            <!-- Newsletter -->
            <v-card flat class="pa-2 mb-2" v-if="!booking.bookingId">
              <v-card-text>
                <v-row class="mx-2 pa-0 align-center">
                  <v-col class="pa-0">
                    <div class=" text-left pr-2">
                      <v-icon class="mr-1 black--text">mdi-email-newsletter</v-icon>
                      {{$t(page+'.Send me news and exclusive invites')}}
                    </div>
                  </v-col>
                  <v-col class="pa-0 shrink">
                    <v-switch class="ml-2" :color="settings.options.color" inset v-model="booking.newsletter" hide-details></v-switch>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- GDPR -->
            <v-card flat class="pa-2 mb-1" v-if="!booking.bookingId">
              <v-card-text class="pb-1">
                <v-row class="mx-2 pa-0 align-center">
                  <v-col class="pa-0">
                    <div class="text-left pr-2">
                      <v-icon class="mr-1 info--text">mdi-check-circle</v-icon>
                      {{$t(page+'.I accept the Terms of Service and Privacy Policy in accordance with GDPR')}}
                    </div>
                  </v-col>
                  <v-col class="pa-0 shrink">
                    <v-switch class="ml-2" :color="settings.options.color" inset v-model="booking.optIn" hide-details></v-switch>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-row justify="center" class="mx-4 mt-16 mb-4">
              <v-btn
                :disabled="!booking.optIn"
                :loading="loading_book"
                outlined
                large
                @click="saveBooking()"
              >
                <v-icon class="mr-2">mdi-check-circle</v-icon>
                {{$t(page+'.Book Now')}}
              </v-btn>
            </v-row>

            <!-- ToC / Privacy link + Anonymize -->
            <div class="d-flex flex-column align-center justify-center" style="position:absolute;bottom:12px;left:0;right:0">
              <div class="d-flex align-center justify-center">
                <v-icon small class="mr-1 grey--text">mdi-open-in-new</v-icon>
                <a
                  href="https://www.ibookrestaurant.it/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-caption grey--text text--darken-1"
                  style="text-decoration:underline"
                >{{$t(page+'.Read Terms of Service and Privacy Policy')}}</a>
              </div>
              <v-btn
                text
                x-small
                outlined
                color="grey darken-1"
                class="mt-3"
                :loading="loading_optOut"
                @click="optOut()"
              >
                <v-icon x-small class="mr-1">mdi-incognito</v-icon>
                {{$t(page+'.Anonymize My Data')}}
              </v-btn>
            </div>

          </div>
        </v-stepper-content>
       
        <!-- STEP 10: STRIPE PAYMENT                         -->
        
        <v-stepper-content step="10">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-204)+'px'">
            <v-card v-if="settings.options.stripeCaptureMethod === 'manual' || (settings.options.stripeCaptureMethod === 'smart' && hoursUntilReservation <= (settings.options.stripeChargeHours / 1))" flat class="pa-0">
              <v-card-title class="pa-2 justify-center text-h4 font-weight-black black--text">
                <v-icon class="mr-2 black--text">mdi-credit-card</v-icon>
                {{$t(page+'.Deposit') }}
              </v-card-title>
              <v-card-text>
                <p class="text-center mb-1">
                  {{$t(page+'.For this timeframe a Deposit is required')}}
                </p>                
                <p class="text-center text-h4 font-weight-black black--text my-3">
                  {{booking.prepaidAmount}} €
                </p>
                <template v-if="currentBooking&&currentBooking.paymentAmount&&booking.prepaidAmount">
                  <p class="text-center mt-3 caption">
                      {{ $t(page+'.Current prepayment of')}} {{currentBooking.paymentAmount}} € {{ $t(page+'.will be immediately refunded once the new deposit is successfully processed') }}
                  </p>
                  <!--<p>{{$t(page+'.Depending on your card provider, it can take 1 to 4 business days to reflect in your balance')}}</p>-->
                </template>               
                <!--
                <p v-if="!booking.forcedDeposit" class="text-center mt-3">
                    {{ $t(page+'.Card only charged in case of a no-show') }}
                </p>
                -->
                <v-alert
                  v-if="freeTables&&booking.slotId&&(freeTables.find(a => a.slotId==booking.slotId)||{}).manualConfirmation>0"
                  color="warning"
                  text
                  class="px-2 pt-1 pb-2 mt-2"
                >
                <p  class="text-center mt-3">
                    {{ $t(page+'.We cannnot confirm your booking just yet Please complete your payment, and we will let you know as soon as our checks are complete If we cannot process it, we will cancel your deposit immediately') }}
                </p>
                </v-alert>

                <!-- Cancel deadline info block -->
                <v-alert
                  :color="cancelDeadlinePassed  ? 'warning' : 'info'"
                  text
                  class="px-2 pt-1 pb-2 mt-2"
                >
                  <!-- CASE 1: Hold payment, deadline still in the future → show free-cancel window -->
                  <p
                    v-if="!cancelDeadlinePassed " class="text-center mt-1 mb-0"
                  >
                    {{ $t(page+'.You can cancel for free until') }}
                    <br /><strong>{{ cancelDeadlineText }}</strong>
                    <br />({{ (settings.options.stripeCancelAuthorizationHours / 1) * ((booking.covers / 1 || 0) + (booking.children / 1 || 0) || 1) }}h {{ $t(page+'.before the reservation') }}).
                    <br />{{ $t(page+'.After that, the hold will be charged as a late cancellation fee') }}.
                  </p>

                  <!-- CASE 2: Hold payment, but the free-cancel window has already closed -->
                  <!--
                  <p
                    v-else-if="cancelDeadlinePassed && (
                      settings.options.stripeCaptureMethod === 'manual' ||
                      (settings.options.stripeCaptureMethod === 'smart' && hoursUntilReservation <= (settings.options.stripeChargeHours / 1))
                    )"
                    class="text-center mt-1 mb-0"
                  >
                    <v-icon small class="warning--text mr-1">mdi-clock-alert</v-icon>
                    {{ $t(page+'.Your card will be held, not charged') }}.
                    <br />
                    {{ $t(page+'.But free cancellation is no longer possible') }}—{{ $t(page+'.since the event date is too close') }}.
                  </p>
                  -->
                  <p
                    v-else
                    class="text-center mt-1 mb-0"
                  >
                    <v-icon small class="warning--text mr-1">mdi-clock-alert</v-icon>
                    {{ $t(page+'.Your card will be held, not charged') }}.
                    <br />
                    {{ $t(page+'.But free cancellation is no longer possible') }}—{{ $t(page+'.since the event date is too close') }}.
                  </p>

                  <!-- CASE 3: Immediate charge — non-refundable -->
                  <!--
                  <p v-else class="text-center mt-1 mb-0">
                    {{ $t(page+'.The amount will be charged and will not be refunded') }}
                  </p>
                    -->
                </v-alert>

                <v-btn
                  large
                  block
                  outlined
                  :loading="stripeLoading"
                  @click="createStripeCheckout"
                  class="mb-3 text-h5 font-weight-bold"
                >
                  {{ $t(page+'.Authorize Deposit')}}
                </v-btn>

              </v-card-text>
            </v-card>
            <v-card v-else flat class="pa-0">
              <v-card-title class="pa-2 justify-center text-h4 font-weight-black black--text">
                <v-icon class="mr-2 black--text">mdi-credit-card</v-icon>
                {{$t(page+'.Pay') }}
              </v-card-title>
              <v-card-text>
                <p class="text-center mb-1">
                  {{$t(page+'.For this timeframe a Prepayment is required')}}
                </p>                
                
                <p class="text-center text-h4 font-weight-black black--text my-3">
                  {{booking.prepaidAmount}} €
                </p>
                <v-alert  
                  v-if="currentBooking&&currentBooking.paymentAmount&&booking.prepaidAmount"
                  color="info"
                  text
                  class="px-2 pt-3 pb-2 mt-2"  
                >

                  <div class="text-center caption">
                      {{ $t(page+'.Current prepayment of')}} {{currentBooking.paymentAmount}} € {{ $t(page+'.will be immediately refunded once the new deposit is successfully processed') }}
                  </div>
                  <!--<p>{{$t(page+'.Depending on your card provider, it can take 1 to 4 business days to reflect in your balance')}}</p>-->
                </v-alert>  
                <v-alert
                  v-if="freeTables&&booking.slotId&&(freeTables.find(a => a.slotId==booking.slotId)||{}).manualConfirmation>0" 
                  color="warning"
                  text
                  class="px-2 pt-3 pb-2 mt-2"
                >
                  <div  class="text-center">
                      {{ $t(page+'.We cannnot confirm your booking just yet Please complete your payment, and we will let you know as soon as our checks are complete If we cannot process it, we will issue an immediate refund') }}
                  </div>
                </v-alert>

                <!-- Cancel deadline info block -->

                <v-alert
                  :color="cancelDeadlinePassed  ? 'warning' : 'info'"
                  text
                  class="px-2 pt-3 pb-2"
                >
                  <!-- CASE 1: Hold payment, deadline still in the future → show free-cancel window -->
                  <p
                    v-if="!cancelDeadlinePassed " class="text-center mt-1 mb-0"
                  >
                    <template v-if="settings.options.stripeChargeFeesOnRefund=='0'">
                      <span class="caption">{{ $t(page+'.You can cancel for free until') }}
                      <br /><strong>{{ cancelDeadlineText }}</strong>
                      <br />{{$t(page+'.After that date your payment goes toward your dinner bill and becomes non-refundable only if you no-show') }}.
                      </span>
                    </template>

                    <template v-else>
                      <span class="caption">
                      {{ $t(page+'.Change of plans? Cancel within')}} 
                      <br /><strong>{{ cancelDeadlineText }}</strong>
                      <br />({{ (settings.options.stripeCancelAuthorizationHours / 1) * ((booking.covers / 1 || 0) + (booking.children / 1 || 0) || 1) }}h {{ $t(page+'.before the reservation') }}).
                      <br />{{ $t(page+'.and you will get a full refund minus the ~2% Stripe fee')}}.
                      </span>
                    </template>
                  </p>

                  <p
                    v-else
                    class="text-center mt-1 mb-0"
                  >
                    <v-icon small class="warning--text mr-1">mdi-clock-alert</v-icon>
                    {{ $t(page+'.No-show policy: The advance payment will be deducted from your final bill. Please note that this deposit is non-refundable in the event of a no-show') }}
                  </p>

                </v-alert>                

                <v-btn
                  large
                  block
                  outlined
                  :loading="stripeLoading"
                  @click="createStripeCheckout"
                  class="mb-3 text-h5 font-weight-bold"
                >
                  {{ $t(page+'.Pay')}}
                </v-btn>

              </v-card-text>
            </v-card>
          </div>
        </v-stepper-content>



        <!-- STEP 11: DUPLICATE BOOKING WARNING             -->
        
        <v-stepper-content step="11">
          <div class="overflow-y-auto warning lighten-3" :style="'height:'+(wHeight-204)+'px'">
            <template v-if="existingBookings">
              <v-card flat class="pa-2 warning lighten-3">
                <v-card-title class="text-h6 font-weight-bold pb-1 d-flex justify-center">
                  <v-icon color="warning" style="font-size:100px">mdi-alert</v-icon>
                  <div class="pr-2 text-h5">{{$t(page+'.Reservation found')}}</div>
                </v-card-title>
                <v-card-text class="text-subtitle-1 px-2">
                  <v-card class="ma-2 py-3 px-5 warning lighten-3">
                    <div>
                      {{$t(page+'.There is an upcoming reservation for')}}
                      <div class="text-center">{{new Date(booking.date).toLocaleDateString(settings.locale, {weekday:'long',month:'long',day:'numeric'})}}</div>
                    </div>
                    <div>{{$t(page+'.associated with')}}
                      <div class="text-center font-weight-bold">{{existingBookings[0].phone.toString().replace(/\d{3,4}?(?=...)/g,'$& ')}}</div>
                    </div>
                    <v-card-text class="d-flex justify-center py-0">
                      <v-btn class="mt-3" small @click="loadExistingBooking(existingBookings[0])" >
                        <v-icon color="warning">mdi-pencil</v-icon>
                        {{$t(page+'.Edit')}}
                      </v-btn>
                      <v-btn class="mt-3 ml-3" small @click="deleteExistingBooking(existingBookings[0])" >
                        <v-icon color="error">mdi-delete</v-icon>
                        {{$t(page+'.Cancel')}}
                      </v-btn>              
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </template>
          </div>
        </v-stepper-content>

        <!-- STEP 14: PROCESSING / SAVING                   -->
        
        <v-stepper-content step="14">
          <div class="overflow-y-auto text-center" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-4">
              <p class="text-h5 mb-4">{{$t(page+'.Please wait')}}...</p>
              <template v-if="!checkResendWA">
                <p class="mx-4 mb-1">{{$t(page+'.We are saving your reservation')}}</p>
                <p v-if="settings.options.WA_sendBookingConfirmation=='1'" class="mx-4 mb-1">{{$t(page+'.and sending you the reminder via WhatsApp')}}</p>
              </template>
              <!--
              <template v-else>
                <p class="mx-4 mb-1">{{$t(page+'.We are resending your reservation confirmation via WhatsApp')}}</p>
              </template>
              -->
              <div class="d-flex justify-center mt-6">
                <v-progress-circular indeterminate size="150" width="10" color="black"></v-progress-circular>
              </div>
            </v-card>
          </div>
        </v-stepper-content>

        <!-- STEP 13: WHATSAPP SENDING (checking delivery)  -->
        <!--
        <v-stepper-content step="13">
          <div class="overflow-y-auto text-center" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-4">
              <p class="text-h5 mb-4">{{$t(page+'.Please wait')}}...</p>
              <p class="mx-4 mb-1">{{$t(page+'.We are checking if whatsapp message has been successfully delivered')}}</p>
              <div class="d-flex justify-center mt-6">
                <v-progress-circular indeterminate size="150" width="10" color="success"></v-progress-circular>
              </div>
            </v-card>
          </div>
        </v-stepper-content>
        -->

        <!-- STEP 13: STRIPE SUCCESS                        -->

        <v-stepper-content step="13">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-2">
              <!--<span>{{stripePaymentData}}</span>-->

              <v-card-title class="py-1 text-h5 d-flex justify-center">
                <v-img src="../../../../static/logos/stripe.png" contain max-width="120" class="mr-2" />
              </v-card-title>
              <v-divider class="fw"></v-divider>
              <v-icon color="success" style="font-size:100px">mdi-check-circle</v-icon>
              <v-card-title class="pt-4 text-h5 d-flex justify-center">
                {{$t(page+'.Transaction completed')}}
              </v-card-title>

              <!-- Payment details -->
              <v-card flat class="px-3 mb-2" v-if="stripePaymentData">
                <v-row dense class="mx-0">
                  <v-col cols="6" class="text-left text-h5  py-1">{{$t(page+'.Amount')}}:</v-col>
                  <v-col cols="6" class="text-right py-1">
                    <span class="font-weight-bold text-h5 pl-3 ">€ {{Number(stripePaymentData.amount).toFixed(2)}}</span>
                  </v-col>
                  <v-col class="text-left text-h5 py-1">{{$t(page+'.Status')}}:</v-col>
                  <v-col class="text-right py-1">
                    <span class="font-weight-bold text-h5 pl-3" :color="stripePaymentData.status==='succeeded'?'success':'warning'" dark>
                      {{stripePaymentData.status==='succeeded'?$t(page+'.Paid'):$t(page+'.Authorized')}}
                    </span>
                  </v-col>
                  <v-col v-if="stripePaymentData.status!=='succeeded'" cols="12" class="caption warning--text text-center pt-2">
                    {{$t(page+'.Card held for no-show; no immediate charge')}}
                  </v-col>
                  <v-col v-else cols="12" class="caption warning--text text-center pt-2">
                    {{$t(page+'.Card has already been charged')}}
                  </v-col>                  
                </v-row>
                <v-row class="mx-0 mt-3">
                  <v-col cols="12" class="px-0 pb-0">
                    <v-progress-linear
                      :value="100 - stripeSuccessProgress"
                      color="success"
                      height="6"
                      rounded
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </v-card>
              <!--
              <v-row justify="center" class="mx-2 mt-5 mb-3">
                <v-btn dark small color="black" @click="closeStripeResult()">
                  <v-icon left small>mdi-check</v-icon>
                  {{$t(page+'.Continue')}}
                </v-btn>
              </v-row>
              -->
            </v-card>
          </div>
        </v-stepper-content>

        <!-- STEP 15: UNCONFIRMED (manual check)            -->
        
        <v-stepper-content step="15">
          <div class="overflow-y-auto text-center" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-4">
              <v-icon color="warning" style="font-size:100px">mdi-check-circle-outline</v-icon>
              <p class="text-h5 warning--text mt-4">{{$t(page+'.RESERVATION')}}</p>
              <p class="text-h5 warning--text mt-n5">{{$t(page+'.UNCONFIRMED')}}</p>                
              <div class="ma-2 px-2">{{$t(page+'.We have received your request for a Reservation')}}:</div>
              <div class="ma-2 px-2">{{$t(page+'.We check availability and we confirm it ASAP')}}.</div>
              <div v-if="settings.options.WA_sendBookingConfirmation==='1'" class="ma-2 px-2">{{$t(page+'.We just sent you a summary via WhatsApp')}}.</div>
              <template v-if="prepayment_done">
                <v-alert v-if="prepayment_action === 'cancel'" type="info" dense outlined class="mt-3 text-left" icon="mdi-cash-remove">
                  {{ $t(page+'.Your previous authorized hold of') }}
                  <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
                  {{ $t(page+'.has been released No charge applied') }}.
                </v-alert>
                <v-alert v-else-if="prepayment_action === 'refund'" type="info" dense outlined class="mt-3 text-left" icon="mdi-cash-remove">
                  {{ $t(page+'.Your payment of') }}
                  <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
                  {{ $t(page+'.has been refunded No charge applied') }}.
                </v-alert>
              </template>
              <div class="text-center mt-4" v-if="isDevv">
                <v-btn outlined block @click="contactStep=0; contactsSendStatus=[]; contactsPolling=false; stepper=23">
                  <v-icon left>mdi-account-multiple-plus</v-icon>
                  {{$t(page+'.'+'Inform your Guests')}}
                </v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn block outlined class=""  @click="reloadPage()">
                  <!--<v-icon class="mr-2">mdi-calendar-check</v-icon>-->
                  {{$t(page+'.Manage your reservations')}}
                </v-btn>                
              </div>              
            </v-card>
          </div>
        </v-stepper-content>
        
        <!-- STEP 16: WAITLISTED                            -->
        <v-stepper-content step="16" >
          <div class="overflow-y-auto text-center" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-4">
              <v-icon color="warning" style="font-size:100px">mdi-check-circle</v-icon>
              <p class="text-h5 warning--text mt-4">{{$t(page+'.RESERVATION')}}</p>
              <p class="text-h5 warning--text mt-n5">{{$t(page+'.WAITLISTED')}}</p>              
              <div class="text-body-2 ma-2 px-2">{{$t(page+'.As soon as a table becomes free, we will confirm your reservation')}}.</div>
              <div v-if="settings.options.WA_sendBookingConfirmation==='1'" class="ma-2 px-2">{{$t(page+'.We just sent you a summary via WhatsApp')}}.</div>
              <template v-if="prepayment_done">
                <v-alert v-if="prepayment_action === 'cancel'" type="info" dense outlined class="mt-3 text-left" icon="mdi-cash-remove">
                  {{ $t(page+'.Your previous authorized hold of') }}
                  <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
                  {{ $t(page+'.has been released No charge applied') }}.
                </v-alert>
                <v-alert v-else-if="prepayment_action === 'refund'" type="info" dense outlined class="mt-3 text-left" icon="mdi-cash-remove">
                  {{ $t(page+'.Your previous payment of') }}
                  <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
                  {{ $t(page+'.has been refunded No charge applied') }}.
                </v-alert>
              </template>
              <div class="text-center mt-4" v-if="isDevv">
                <v-btn outlined block @click="contactStep=0; contactsSendStatus=[]; contactsPolling=false; stepper=23">
                  <v-icon left>mdi-account-multiple-plus</v-icon>
                  {{$t(page+'.'+'Inform your Guests')}}
                </v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn block outlined class=""  @click="reloadPage()">
                  <!--<v-icon class="mr-2">mdi-calendar-check</v-icon>-->
                  {{$t(page+'.Manage your reservations')}}
                </v-btn>                
              </div>
            </v-card>
          </div>
        </v-stepper-content>
        
        <!-- STEP 17: CONFIRMED (altered reservation)       -->
        <v-stepper-content step="17">
          <div class="overflow-y-auto text-center" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="px-4">
              <v-icon color="success" style="font-size:100px">mdi-check-circle</v-icon>
              <p class="text-h5 success--text mt-4">{{$t(page+'.RESERVATION')}}</p>
              <p class="text-h5 success--text mt-n5">{{$t(page+'.CONFIRMED')}}</p>
              <div class="text-center warning--text mb-2">{{$t(page+'.Thank you for altering your Reservation')}}</div>
              <div v-if="settings.options.WA_sendBookingConfirmation==='1'">
                {{$t(page+'.We just sent you a summary via WhatsApp')}}.
              </div>
              <template v-if="prepayment_done">
                <v-alert v-if="prepayment_action === 'cancel'" type="info" dense outlined class="mt-3 text-left" icon="mdi-cash-remove">
                  {{ $t(page+'.Your previous authorized hold of') }}
                  <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
                  {{ $t(page+'.has been released No charge applied') }}.
                </v-alert>
                <v-alert v-else-if="prepayment_action === 'refund'" type="info" dense outlined class="mt-3 text-left" icon="mdi-cash-remove">
                  {{ $t(page+'.Your previous payment of') }}
                  <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
                  {{ $t(page+'.has been refunded No charge applied') }}.
                </v-alert>
              </template>
              <div class="text-center mt-3">
                <v-btn block outlined class=""  @click="reloadPage()">
                  <!--<v-icon class="mr-2">mdi-calendar-check</v-icon>-->
                  {{$t(page+'.Manage your reservations')}}
                </v-btn>                
              </div>
              <div v-if="settings.options.menuURL&&!bookingId" class="text-center mt-4">
                <v-btn outlined block :href="settings.options.menuURL" class="" @click="open_confirm_dialog=false;reset()">
                  <v-icon class="mr-2">mdi-silverware</v-icon>
                  {{$t(page+'.Browse our Menu')}}
                </v-btn>
              </div>
              <div class="text-center mt-3" v-if="isDevv">
                <v-btn outlined block @click="contactStep=0; contactsSendStatus=[]; contactsPolling=false; stepper=23">
                  <v-icon left>mdi-account-multiple-plus</v-icon>
                  {{$t(page+'.'+'Inform your Guests')}}
                </v-btn>
              </div>
            </v-card>
          </div>
        </v-stepper-content>        

        <!-- STEP 18: CONFIRMED (success)                   -->
        <v-stepper-content step="18">
          <div class="overflow-y-auto text-center" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="px-4">
              <v-icon color="success" style="font-size:100px">mdi-check-circle</v-icon>
              <p class="text-h5 success--text mt-4">{{$t(page+'.RESERVATION')}}</p>
              <p class="text-h5 success--text mt-n5">{{$t(page+'.CONFIRMED')}}</p>
              <!--<div v-if="bookingId" class="text-body-2 text-center mb-2">{{$t(page+'.Thank you for altering your Reservation')}}</div>-->
              <div class="text-center mb-2">{{$t(page+'.Thank you for your Reservation')}}</div>
              <!--
              <div v-if="settings.options.WA_sendBookingConfirmation==='1'">
                {{$t(page+'.We just sent you a summary via WhatsApp')}}.
              </div>
              -->
              <template v-if="prepayment_done">
                <v-alert v-if="prepayment_action === 'cancel'" type="info" dense outlined class="mt-3 text-left" icon="mdi-cash-remove">
                  {{ $t(page+'.Your previous authorized hold of') }}
                  <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
                  {{ $t(page+'.has been released No charge applied') }}.
                </v-alert>
                <v-alert v-else-if="prepayment_action === 'refund'" type="info" dense outlined class="mt-3 text-left" icon="mdi-cash-remove">
                  {{ $t(page+'.Your previous payment of') }}
                  <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
                  {{ $t(page+'.has been refunded No charge applied') }}.
                </v-alert>
              </template>
              <div class="text-center mt-3">
                {{$t(page+'.Need to change or cancel Use the Book a table button on the restaurants Google page or website')}}.
              </div>
              <div class="text-center mt-3" v-if="isDevv">
                <template>
                  <!-- v-if automatically hides the button until the prompt is ready -->
                  <v-btn 
                    v-if="showInstallButton" 
                    color="primary" 
                    @click="promptInstall"
                  >
                    <v-icon left>mdi-cellphone-arrow-down</v-icon>
                    Install App
                  </v-btn>
                </template>
              </div>

              <div class="text-center mt-3">
                <v-btn block outlined class=""  @click="reloadPage()">
                  <!--<v-icon class="mr-2">mdi-calendar-check</v-icon>-->
                  {{$t(page+'.Manage your reservations')}}
                </v-btn>                
              </div>
              <div class="text-center mt-3" v-if="isDevv">
                <v-btn outlined block @click="contactStep=0; contactsSendStatus=[]; contactsPolling=false; stepper=23">
                  <v-icon left>mdi-account-multiple-plus</v-icon>
                  {{$t(page+'.'+'Inform your Guests')}}
                </v-btn>
              </div>
              <div v-if="settings.options.menuURL&&!bookingId" class="text-center mt-4">
                <v-btn outlined block :href="settings.options.menuURL" class="" @click="open_confirm_dialog=false;reset()">
                  <v-icon class="mr-2">mdi-silverware</v-icon>
                  {{$t(page+'.Browse our Menu')}}
                </v-btn>
              </div>
            </v-card>
          </div>
        </v-stepper-content>

        <!-- STEP 19: EDIT ON WAITLISTED SLOT — ORIGINAL CONFIRMED, CHANGES PENDING -->
        <v-stepper-content step="19">
          <div class="overflow-y-auto text-center" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-4">
              <v-icon color="success" style="font-size:100px">mdi-check-circle</v-icon>
              <p class="text-h5 success--text mt-4">{{$t(page+'.RESERVATION')}}</p>
              <p class="text-h5 success--text mt-n5">{{$t(page+'.CONFIRMED')}}</p>
              <p class="text-body-2 grey--text mb-4">{{$t(page+'.Changes are pending restaurant approval You will be notified via WhatsApp ASAP')}}</p>

              <!-- Full comparison: all fields, arrow only when value changed -->
              <v-card outlined class="mb-4 text-left">
                <v-list dense>
                  <v-list-item v-for="d in bookingFullDiff" :key="d.key" class="px-3">
                    <v-list-item-content>
                      <v-list-item-title class="text-caption grey--text text-uppercase font-weight-bold">
                        {{ $t(page+'.'+d.key) }} :
                        <template v-if="d.changed">
                          <span class="text-decoration-line-through grey--text ml-2mr-1">{{ d.old }}</span>
                          <v-icon x-small class="mx-1">mdi-arrow-right</v-icon>
                          <strong class="warning--text">{{ d.now }}</strong>
                        </template>
                        <template v-else>
                          <strong class="black--text">{{ d.old }}</strong>
                        </template>                        
                      </v-list-item-title>
                      <!--
                      <v-list-item-subtitle class="text-body-2">
                        <template v-if="d.changed">
                          <span class="text-decoration-line-through grey--text mr-1">{{ d.old }}</span>
                          <v-icon x-small class="mx-1">mdi-arrow-right</v-icon>
                          <strong class="warning--text">{{ d.now }}</strong>
                        </template>
                        <template v-else>
                          <strong class="black--text">{{ d.old }}</strong>
                        </template>
                      </v-list-item-subtitle>
                      -->
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>

              <div v-if="settings.options.WA_sendBookingConfirmation==='1'" class="mb-4">
                {{$t(page+'.We just sent you a summary via WhatsApp')}}.
              </div>

              <div>
                {{$t(page+'.Need to change or cancel Use the Book a table button on the restaurants Google page or website')}}.
              </div>

              <div class="text-center mt-3">
                <v-btn block outlined @click="reloadPage()">
                  {{$t(page+'.Manage your reservations')}}
                </v-btn>
              </div>
            </v-card>
          </div>
        </v-stepper-content>

        <!-- STEP 21: WA TOTALLY FAILED → CALL US           -->
        <v-stepper-content step="21">
          <div class="overflow-y-auto text-center" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-4">
              <v-card-title class="text-h6 font-weight-bold pb-1">
                {{$t(page+'.WhatsApp Failed')}}
                <v-spacer></v-spacer>
                <v-icon color="error">mdi-whatsapp</v-icon>
              </v-card-title>
              <v-card-text>
                <p class="text-body-1 mx-4">{{$t(page+'.We are Sorry, but the attempts to send you the WhatsApp message to confirm Your reservation has failed')}}</p>
                <p class="text-center">{{$t(page+'.Please make your reservation calling')}}</p>
                <p class="text-center text-h6 my-2">{{settings.options.bookingNumber}}</p>
                <template v-if="(new Date().getHours()+':'+new Date().getMinutes())>settings.options.pbxRecallTime">
                  <div class="d-flex justify-center my-3">
                    <v-btn :href="'tel:39'+(settings&&settings.options.bookingNumber.replace(/\s+/g, ''))" color="black">
                      {{$t(page+'.Call Us')}}
                      <v-icon class="ml-3">mdi-phone</v-icon>
                    </v-btn>
                  </div>
                </template>
                <p v-else class="my-2 text-center">{{$t(page+'.after')}} {{settings.options.pbxRecallTime}}</p>
              </v-card-text>
            </v-card>
          </div>
        </v-stepper-content>
        
        <!-- STEP 20: STRIPE FAILED                         -->
        <v-stepper-content step="20">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-2">
              <v-card-title class="py-1 text-h5 d-flex justify-center">
                <v-img src="../../../../static/logos/stripe.png" contain max-width="160" class="mr-2" />
              </v-card-title>
              <v-divider class="fw"></v-divider>
              <v-icon color="error" style="font-size:120px">mdi-close-thick</v-icon>              
              <v-card-title class="pt-4 text-h5 d-flex justify-center">
                {{$t(page+'.Payment Failed')}}
              </v-card-title>


              <v-alert v-if="stripePaymentData && stripePaymentData.errorMessage" type="error" text dense class="ma-3 text-h5">
                {{stripePaymentData.errorMessage}}
              </v-alert>

              <!--<div v-if="stripePaymentData && stripePaymentData.errorCode" class="mt-4 grey--text">{{$t(page+'.Error Code')}}: {{stripePaymentData.errorCode}}</div>-->

              <v-row justify="center" class="mx-2 mt-7">
                <v-btn small   @click="retryStripePayment()" class="mr-2">
                  <v-icon color="info" left>mdi-refresh</v-icon>
                  {{$t(page+'.Try Again')}}
                </v-btn>
                <v-btn small @click="closeStripeResult()">
                  <v-icon color="error" left>mdi-close</v-icon>
                  {{$t(page+'.Cancel')}}
                </v-btn>
              </v-row>
            </v-card>
          </div>
        </v-stepper-content>

        <!-- STEP 22: STRIPE 3DS PENDING                    -->

        <v-stepper-content step="22">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-204)+'px'">
            <v-card flat class="pa-2">
              <v-card-title class="py-1 text-h5 d-flex justify-center">
                <v-img src="../../../../static/logos/stripe.png" contain max-width="120" class="mr-2" />
              </v-card-title>
              <v-divider class="fw"></v-divider>
              <v-card-title class="py-1 text-h5 d-flex justify-center">
                {{$t(page+'.Payment Pending Authentication')}}
              </v-card-title>

              <v-card flat class="pa-3 mb-1">
                <v-row dense class="mx-0 align-center">
                  <v-col cols="12" class="text-center py-3">
                    <v-progress-circular indeterminate size="48" width="4" color="warning"></v-progress-circular>
                  </v-col>
                  <v-col cols="12" class="text-center caption grey--text text--darken-1 pb-1">
                    {{$t(page+'.Your card requires additional authentication')}}
                  </v-col>
                  <v-col cols="12" class="text-center caption grey--text pb-2">
                    {{$t(page+'.Please complete the verification on your banking app or SMS')}}
                  </v-col>
                </v-row>
              </v-card>

              <v-row justify="center" class="mx-2 mt-1 mb-3">
                <v-btn small outlined color="black" @click="checkStripePaymentStatus()" :loading="stripeLoading">
                  <v-icon left small>mdi-refresh</v-icon>
                  {{$t(page+'.Check Status')}}
                </v-btn>
              </v-row>
            </v-card>
          </div>
        </v-stepper-content>

        <!-- STEP 23: INVITE GUESTS                         -->
        <v-stepper-content step="23">
          <div class="overflow-y-auto" :style="'height:'+(wHeight-204)+'px'">
            <v-card elevation="2" class="ma-2">
              <v-card-title class="headline">
                <v-icon left color="primary">mdi-account-box-multiple</v-icon>
                {{$t(page+'.'+'Inform your Guests')}}
                <v-spacer></v-spacer>
                <v-btn icon small v-if="contactStep > 0" @click="contactStep=0; contactsSendStatus=[]">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <!-- Step 0: pick contacts -->
                <template v-if="contactStep===0">
                  <v-btn v-if="isSupported_contacts" block large :loading="loading" @click="selectContacts">
                    <v-icon left>mdi-account-search</v-icon>
                    {{$t(page+'.'+'Select contacts')}}
                  </v-btn>
                  <div class="text-center mt-1" v-if="isDevv">
                    <v-btn text x-small color="grey darken-1" @click="simulateContacts">
                      <v-icon x-small left>mdi-bug</v-icon>Simula contatti (debug)
                    </v-btn>
                  </div>
                  <template v-if="contacts.length">
                    <v-divider class="my-3"></v-divider>
                    <v-list dense two-line class="py-0">
                      <v-subheader>{{ contacts.length }} {{$t(page+'.'+'Contacts selected')}}</v-subheader>
                      <v-list-item v-for="(contact, idx) in contacts" :key="idx">
                        <v-list-item-avatar size="28" color="grey lighten-2">
                          <v-icon small>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{ getContactName(contact) }}</v-list-item-title>
                          <v-list-item-subtitle v-if="contact.tel && contact.tel.length" class="caption">📞 {{ contact.tel[0] }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon x-small @click="contacts.splice(idx,1)"><v-icon small>mdi-close</v-icon></v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <v-btn block dark color="black" class="mt-2" @click="contactStep=1">
                      <v-icon left>mdi-arrow-right</v-icon>
                      {{$t(page+'.'+'Choose the message')}} ({{ contacts.length }})
                    </v-btn>
                  </template>
                </template>

                <!-- Step 1: template picker + preview + consent -->
                <template v-else-if="contactStep===1">
                  <div class="text-subtitle-2 mb-2">{{$t(page+'.'+'Message type')}}:</div>
                  <v-row dense>
                    <v-col v-for="tpl in contactTemplates" :key="tpl.key" cols="4">
                      <v-card
                        outlined
                        :class="['pa-2 text-center', selectedTemplate===tpl.key ? 'black white--text elevation-4' : '']"
                        style="cursor:pointer;min-height:82px"
                        @click="selectedTemplate=tpl.key"
                      >
                        <v-icon :color="selectedTemplate===tpl.key?'white':'black'" class="mb-1">{{ tpl.icon }}</v-icon>
                        <div class="text-caption font-weight-bold" :class="selectedTemplate===tpl.key?'white--text':''">
                          {{ tpl.label }}
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-card flat outlined class="pa-3 mt-3 grey lighten-4" v-if="selectedTemplate">
                    <div class="text-caption grey--text mb-1">{{$t(page+'.'+'Preview')}}:</div>
                    <div class="text-body-2" style="white-space:pre-wrap">{{ contactMessagePreview }}</div>
                  </v-card>
                  <v-text-field
                    v-model="contactCustomSentence"
                    :label="$t(page+'.'+'Personal message (optional)')"
                    prepend-inner-icon="mdi-pencil"
                    outlined dense class="mt-3"
                    hide-details maxlength="120"
                  ></v-text-field>
                  <div class="caption grey--text text-center mt-2 mb-1">
                    {{$t(page+'.'+'By pressing Send you authorize sending a WhatsApp message to the selected contacts')}}.
                  </div>
                  <v-btn block dark color="black" large class="mt-1"
                    :disabled="!selectedTemplate"
                    :loading="contactsSending"
                    @click="sendContactsInvite()"
                  >
                    <v-icon left>mdi-whatsapp</v-icon>
                    {{$t(page+'.'+'Send invitations')}} ({{ contacts.length }})
                  </v-btn>
                  <v-btn text small block class="mt-2" @click="contactStep=0">
                    <v-icon left small>mdi-arrow-left</v-icon>{{$t(page+'.'+'Edit Contacts')}}
                  </v-btn>
                </template>

                <!-- Step 2: per-contact send + delivery status -->
                <template v-else-if="contactStep===2">
                  <div class="d-flex align-center mb-3">
                    <v-progress-circular v-if="contactsSending" indeterminate size="18" width="2" color="black" class="mr-2"></v-progress-circular>
                    <v-icon v-else color="success" class="mr-2">mdi-check-circle</v-icon>
                    <span class="text-subtitle-2">{{ contactsSending ? $t(page+'.'+'Invio in corso') + '…' : $t(page+'.'+'Sending in progress')}}</span>
                    <v-spacer></v-spacer>
                    <v-progress-circular v-if="contactsPolling" indeterminate size="18" width="2" color="teal" class="ml-2"></v-progress-circular>
                  </div>
                  <v-list dense class="py-0">
                    <v-list-item v-for="(cs, idx) in contactsSendStatus" :key="idx" class="px-0">
                      <v-list-item-avatar size="28">
                        <v-icon :color="contactStatusColor(cs.status)" size="22">{{ contactStatusIcon(cs.status) }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2 font-weight-medium">{{ cs.name }}</v-list-item-title>
                        <v-list-item-subtitle class="caption">{{ cs.phone }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <span class="caption font-weight-bold" :class="contactStatusColor(cs.status)+'--text'">{{ contactStatusLabel(cs.status) }}</span>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </template>

              </v-card-text>
            </v-card>
          </div>
        </v-stepper-content>
        <!-- END STEP 23 -->

        <!-- STEP 30: EXISTING RESERVATIONS SELECT           -->
          <v-stepper-content step="30" class="pt-0 px-2">
            <div class="overflow-y-auto" :style="'height:'+(wHeight-204)+'px'">
              <div class="pa-2">

                <div class="d-flex justify-center align-center pb-3">
                  <v-icon class="mr-2" color="black">mdi-calendar-check-outline</v-icon>
                  <span class="text-h6 font-weight-bold">{{ $t(page+'.Active Reservations')}}</span>
                </div>

                <!-- List each open booking -->
                <v-card
                  v-for="(ob, idx) in openBookings"
                  :key="idx"
                  outlined
                  class="mb-3 booking-card pa-2"
                >
                  <v-row class="mx-0 mt-3">
                    <v-col class="px-0">
                      <v-icon large color="black" class="mr-2">mdi-calendar</v-icon>
                      <span class="text-body-1 font-weight-bold">
                        {{ ob.date ? formatDate(ob.date,'wdM'):''}}
                      </span>
                    </v-col>
                    <v-col class="px-0">
                      <v-icon large color="black" class="mr-1">mdi-human-male-female</v-icon>
                      <span class="text-body-1 font-weight-bold">{{ ob.covers }}</span>
                      <v-icon color="black" class="mr-1 pl-2 pt-2">mdi-human-child</v-icon>
                      <span class="text-body-1 font-weight-bold">{{ ob.children }}</span>
                    </v-col>
                  </v-row>

                  <v-row class="mx-0">
                    <v-col class="px-0">
                        <v-icon large color="black" class="mr-2">mdi-clock-start</v-icon>
                        <span class="text-body-1 font-weight-bold mr-2">{{ ob.time }}</span>
                    </v-col>
                    <v-col class="px-0">
                        <v-icon
                          large
                          class="mr-1"
                          :color="ob.mealDuration<ob.defaultMealDuration ? 'warning' : (ob.mealDuration>ob.defaultMealDuration ? 'success' : 'black')"
                        >mdi-clock-end</v-icon>
                        <span class="text-body-1 font-weight-bold mr-2">{{ ob.tableReservedUntil }}</span>
                    </v-col>
                  </v-row>

                  <v-row class="mx-0">
                    <v-col class="px-0">
                      <v-icon large color="black" class="mr-2">{{ ob.icon }}</v-icon>
                      <span class="text-body-1 font-weight-bold flex-grow-1">{{ $t(page + '.' + ob.locationName) }}</span>
                    </v-col>
                    <v-col class="px-0">
                      <v-icon large :color="ob.color" class="mr-1">{{ ob.iconStatus }}</v-icon>
                      <span class="text-body-1 font-weight-bold font-weight-bold">{{ $t(page+'.'+ob.status) }}</span>
                    </v-col>
                  </v-row>

                  <v-row class="mx-0" v-if="ob.paymentAmount">
                    <v-col class="px-0">
                      <v-icon large color="black" class="mr-2">mdi-cash</v-icon>
                      <span class="text-body-1 font-weight-bold flex-grow-1">{{ ob.paymentAmount }} €</span>
                    </v-col>
                    <v-col class="px-0">
                      <v-icon large
                        v-if="ob.stripeStatus=='requires_capture'"
                        color="green darken-1" class="mr-1"
                      >mdi-cash-clock</v-icon>
                      <v-icon
                        v-else
                        large
                        color="warning" class="mr-1"
                      >mdi-cash-lock</v-icon>
                      <span class="text-body-1 font-weight-bold">{{ $t(page+'.'+ob.stripeStatus) }}</span>
                    </v-col>
                  </v-row>

                  <v-divider class="fw"></v-divider>

                  <v-row class="mx-0 pt-2">
                    <v-col>
                      <v-btn
                        block outlined color="black" class="app-btn"
                        @click="loadNoAlterRefundedReservationDialog(ob)"
                        v-if="settings.options.stripeChargeFeesOnRefund==='0'&&ob.refundedCount>0"
                      >
                        <v-icon size="18" left>mdi-pencil-outline</v-icon>
                        {{$t(page+'.Edit')}}
                      </v-btn>
                      <v-btn
                        block outlined color="black" class="app-btn"
                        @click="loadExistingBooking(ob)"
                        v-else
                      >
                        <v-icon size="18" left>mdi-pencil-outline</v-icon>
                        {{$t(page+'.Edit')}}
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        block outlined color="error" class="app-btn"
                        @click="deleteExistingBooking(ob)"
                      >
                        <v-icon size="18" left>mdi-delete-outline</v-icon>
                        {{$t(page+'.Cancel')}}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- Make a new reservation instead -->
                <div class="text-center pb-3 pt-1">
                  <v-btn
                    outlined large block class="app-btn"
                    @click="openBookings=null; stepper=2"
                  >
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    {{ $t(page+'.New Reservation') }}
                  </v-btn>
                </div>

              </div>
            </div>
          </v-stepper-content>
        <!-- END STEP 30 -->

      </v-stepper-items>
    </v-stepper>

    <!-- OTP WhatsApp Privacy Dialog (shown after 2 failed resend attempts) -->
    <v-dialog v-model="otpPrivacyDialog" max-width="440" persistent>
      <v-card outlined>
        <v-card-title class="text-subtitle-1 font-weight-bold pb-1">
          <v-icon class="mr-2 green--text">mdi-whatsapp</v-icon>
          {{$t(page+'.WhatsApp Verification')}}
          <v-spacer></v-spacer>
          <v-btn fab icon small @click="otpPrivacyDialog=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider class="fw"></v-divider>
        <v-card-text class="pt-4 pb-2 text-body-2">
          <p class="mb-3">
            {{$t(page+'.UpdateWA1')}}
          </p>
          <p class="mb-3">
            {{$t(page+'.UpdateWA2')}}
          </p>
        </v-card-text>
        <v-card-actions class="justify-center pb-3">
          <v-btn
            outlined
            color="black"
            @click="otpPrivacyDialog=false; otpResendCount=0"
          >
            <v-icon small class="mr-1">mdi-refresh</v-icon>
            {{$t(page+'.Restart Procedure')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialog_showMealInfo" max-width="380">
      <v-card v-if="freeTable">
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <template v-if="freeTable.item=='bonus'">
            <v-icon large color="success">mdi-glass-flute</v-icon>
            {{ $t(page+'.Gift') }}
          </template>

          <template v-else-if="freeTable.item=='prepayment'">
            <v-icon large color="info">mdi-currency-eur</v-icon>
            {{ $t(page+'.Prepayment/Deposit') }}
          </template>

          <template v-else-if="freeTable.item=='rushhours'">
            <v-icon large color="error">mdi-fire</v-icon>
            {{ $t(page+'.Avoid the rush') }}
          </template>

          <template v-else-if="freeTable.item=='duration'">
            <v-icon large color="warning">mdi-clock-fast</v-icon>
            {{ $t(page+'.QuickMeal') }}
          </template>          

          <v-spacer></v-spacer>
          <v-btn fab icon small @click="dialog_showMealInfo=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="text-body-2 pt-2" v-if="freeTable">
          <v-row v-if="freeTable.item=='bonus'">
            <v-col>
                {{ $t(page+'.We offer You') }} {{freeTable.bonus}}
            </v-col>
          </v-row>
          <v-row v-else-if="freeTable.item=='prepayment'">
            <v-col>
                {{ $t(page+'.It is required a Prepayment/Deposit of') }} {{freeTable.prepayment*(booking.covers+booking.children)}} €.
            </v-col>
          </v-row>
          <v-row v-if="freeTable.item=='rushhours'">
            <v-col>
                {{ $t(page+'.Select an off-peak time to enjoy a better experience with no waiting') }}
            </v-col>
          </v-row>          
          <v-row v-if="freeTable.item=='duration'">
            <v-col>
                {{ $t(page+'.To accommodate all bookings, we kindly request that your table is vacated by') }} {{new Date(freeTable.rTo * 1000).toISOString().slice(11, 16)}}.
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog: readonly phone/country tap -->
    <v-dialog v-model="dialog_readonly_phone" max-width="380">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon left color="info">mdi-lock</v-icon>
          {{ $t(page+'.Phone number locked') }}
        </v-card-title>
        <v-card-text class="text-body-2 pt-2">
          {{ $t(page+'.Your phone number is linked to this device') }}.
          {{ $t(page+'.To use a different number, delete your account first, then re-register with the new number') }}.
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog_readonly_phone = false; $emit('wipe-out')">
            <v-icon left small>mdi-delete-forever</v-icon>
            {{ $t(page+'.Delete User') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="dialog_readonly_phone = false">{{ $t(page+'.OK') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for Bulk Booking (12+ guests) -->
    <v-dialog v-model="showSameDayDialog" max-width="420">
      <v-card outlined>
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon class="mr-3">
            mdi-phone
          </v-icon>
          {{$t(page+'.Give us a Call')}}
          <v-spacer></v-spacer>
          <v-btn fab icon small @click="showSameDayDialog=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider class="fw"></v-divider>
        <v-card-text class="text-body-1 px-6 py-4">
          <v-col class="text-center" >
            <p class="text-h6 mb-0">
              {{$t(page+'.We are nearly at full capacity today')}}.
            </p>
            <p class="text-h6 mb-0">
              {{$t(page+'.But please feel free to call us: we will do our best to accommodate you')}}
            </p>
          </v-col>
          <v-col cols="12" md="12">
            <div class="text-center">
              <template v-if="settings&&settings.options&&settings.options.bookingNumber">
                  <p class="text-h5 font-weight-bold mb-2">{{settings.options.bookingNumber}}</p>
                <v-btn class="neu-glow" outlined :href="'tel:+39'+(settings&&settings.options.bookingNumber.replace(/\s+/g, ''))">
                  <v-icon color="info" class="mr-3">mdi-phone</v-icon>
                  {{$t(page+'.Call')}}
                </v-btn>
              </template>
            </div>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog for Bulk Booking (12+ guests) -->
    <v-dialog v-model="dialog_more_than" max-width="420">
      <v-card outlined>
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon class="mr-2 black--text">mdi-account-group</v-icon>
          {{$t(page+'.Bulk Booking')}}
          <v-spacer></v-spacer>
          <v-btn fab icon small @click="dialog_more_than=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="text-body-1 px-6 py-4">
          <p class="text-center mb-3">
            {{$t(page+'.For bookings above')}} {{settings.options.maxBookableCovers}} {{$t(page+'.guests, please call')}}:
          </p>
          <p class="text-center text-h5 font-weight-bold black--text mb-3">{{settings.options.bookingNumber}}</p>
        </v-card-text>
        <v-card-actions v-if="settings&&settings.options.bookingNumber" class="justify-center pb-4">
          <v-btn :href="'tel:'+(settings&&settings.options&&settings.options&&settings.options&&settings.options.bookingNumber.replace(/\s/g,''))" outlined large>
            <v-icon left>mdi-phone</v-icon>
            {{$t(page+'.Call')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for Stripe Payment (embedded form) -->
    <v-dialog v-model="dialog_stripe" max-width="480" persistent class="mx-2">
      <v-card outlined>
        <v-card-title class="py-2 text-h5 d-flex justify-center">
          <v-img src="../../../../static/logos/stripe.png" contain max-width="140" class="mr-2" />
          <v-spacer class="fw"></v-spacer>
          <v-btn fab icon small @click="cancelStripe()" :disabled="stripeLoading"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <!--        
        <v-card-title class="text-h6">
          <v-icon class="mr-2 black--text">mdi-lock</v-icon>
          Stripe {{$t(page+'.Secure Payment')}}
          <v-spacer class="fw"></v-spacer>
          <v-btn fab icon small @click="cancelStripe()" :disabled="stripeLoading"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        -->
        <v-divider class="fw"></v-divider>
        <v-card-text class="px-5 pt-4 pb-2">
          <p class="text-center text-h4 font-weight-black black--text mb-4">{{booking.prepaidAmount}} €</p>
          <v-card v-if="WLH.includes('aibooking')">
            <div class="text-center caption font-weight-black">{{$t(page+'.Test data')}}:</div>
            <div class="text-center caption">VISA US: 4242 4242 4242 4242</div>
            <div class="text-center caption">VISA IT: 4000 0038 0000 0008</div>
            <div class="text-center caption">{{$t(page+'.Expiration Date')}}: 12/29</div>
            <div class="text-center caption">{{$t(page+'.Security Code')}}: 333</div>
          </v-card>
          <!-- Wallet (Google/Apple Pay) -->
          <div v-if="stripeWalletAvailable" class="mb-3">
            <div ref="stripe_wallet_div"></div>
            <div class="d-flex align-center my-3">
              <span class="mx-3 caption grey--text">{{$t(page+'.Or pay with card')}}</span>
            </div>
          </div>

          <!-- Card Element -->
          <div ref="stripe_div" class="mb-3"></div>

          <v-alert v-if="stripeExtendedAuthFallbackActive" type="info" dense class="mt-2 mb-1 text-caption">
            {{$t(page+'.Your card does not support a deferred charge for this booking. Please confirm the payment now to complete your reservation.')}}
          </v-alert>
          <!--
          <v-alert v-if="stripeError" type="error" dense class="mt-2">{{$t(page+'.Payment failed')}}</v-alert>
          <v-alert v-if="stripePaid" type="success" dense class="mt-2">{{$t(page+'.Payment successful')}}</v-alert>
          -->
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn dark v-if="!stripePaid&&!stripeError" :loading="stripeLoading" color="black" small @click="confirmStripePayment">
            <v-icon left>mdi-lock</v-icon>
            {{$t(page+'.Pay now')}}
          </v-btn>
          <v-btn dark v-if="stripeError"  :color="settings.options.color||'warning'" @click="retryStripeBtn">
            <v-icon left>mdi-refresh</v-icon>
            {{$t(page+'.Retrys')}}
          </v-btn>
          <v-btn text @click="cancelStripe()">{{$t(page+'.Cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_cancel_booking" max-width="380" persistent>
      <v-card outlined>
        <v-card-title class="text-subtitle-1 font-weight-bold pb-1">
          <v-icon class="mr-2 error--text">mdi-delete</v-icon>
          {{$t(page+'.Cancel Reservation')}}
          <v-spacer></v-spacer>
          <v-btn fab icon small @click="dialog_cancel_booking=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider class="fw"></v-divider>
        <v-card-text class="pt-4 pb-2 text-body-1">
          <v-card flat class="pa-3 rounded" v-if="currentBooking">
            <div class="font-weight-bold text-center">
              <v-icon large class="mr-1 mt-n2">mdi-calendar</v-icon>
              <span v-if="currentBooking.time" class="mr-3 text-h6">{{ currentBooking.date ? formatDate(currentBooking.date,'WdN') : '' }}</span>              
            </div>
            <div class="font-weight-bold pt-2">
              <v-row>
                <v-col class="text-center">
                  <v-icon large class="mr-1 mt-n2">mdi-clock</v-icon>
                  <span v-if="currentBooking.time" class="mr-3 text-h6">{{ currentBooking.time }}</span>
                </v-col>
                <v-col class="text-center">
                  <v-icon large  class="mr-1 mt-n2">mdi-account-group</v-icon>
                  <span v-if="currentBooking.time" class="mr-3 text-h6">{{ currentBooking.covers }}+{{ currentBooking.children }}</span>              
                </v-col>
              </v-row>
            </div>
          </v-card>
          <!-- Payment loss warning -->
          <!--
          <div v-if="currentBooking">
            {{currentBooking}}|{{currentBooking.stripeStatus}}|{{currentBooking.hoursUntilReservation}}|{{settings.options.stripeCancelAuthorizationHour}}|{{currentBooking.covers+currentBooking.children}}
          </div>
          -->
          
          <template v-if="currentBooking && currentBooking.paymentAmount">

            <!-- MANUAL capture + still within cancellation window → safe to cancel (auth will be released) -->
            <v-alert
              text
              v-if="currentBooking.stripeStatus === 'requires_capture' && currentBooking.hoursUntilReservation >= (settings.options.stripeCancelAuthorizationHours / 1)*(currentBooking.covers+currentBooking.children)"
              color="info"
              dense
              outlined
              class="mt-3 mb-0 text-body-2"
            >
              <strong>{{ $t(page+'.Info') }}:</strong>
              {{ $t(page+'.You have an authorized hold of') }}
              <strong>€ {{ Number(currentBooking.paymentAmount).toFixed(2) }}</strong>
              {{ $t(page+'.If you cancel now the authorization will be released and no charge will apply') }}.
            </v-alert>

            <!-- MANUAL capture + too close to reservation → authorization will be captured -->
            <v-alert
              v-else-if="currentBooking.stripeStatus === 'requires_capture' && currentBooking.hoursUntilReservation < (settings.options.stripeCancelAuthorizationHours / 1)*(booking.covers+booking.children)"
              text
              color="warning"
              dense
              outlined
              class="mt-3 mb-0 text-body-2"
            >
              <strong>{{ $t(page+'.Warning') }}:</strong>
              {{ $t(page+'.You have an authorized hold of') }}
              <strong>€ {{ Number(currentBooking.paymentAmount).toFixed(2) }}</strong>
              {{ $t(page+'.The reservation is less than') }}
              <strong>{{ settings.options.stripeCancelAuthorizationHours }}</strong>
              {{ $t(page+'.hours away — cancelling now may result in the hold being charged') }}.
            </v-alert>

            <!-- AUTOMATIC capture → payment already charged, non-refundable -->
            <v-alert
              v-else
              color="error"
              text
              dense
              outlined
              class="mt-3 mb-0 text-body-2"
            >
              <strong>{{ $t(page+'.Warning') }}:</strong>
              {{ $t(page+'.You have a prepayment of') }}
              <strong>€ {{ Number(currentBooking.paymentAmount).toFixed(2) }}</strong>
              {{ $t(page+'.which is not refundable if you cancel') }}.
            </v-alert>

          </template>
        </v-card-text>
        <v-card-actions class="justify-center pb-4 pt-2">
          <v-btn color="error" dark :loading="loading_cancel" @click="cancelBooking()">
            <v-icon small class="mr-1">mdi-delete</v-icon>
            {{$t(page+'.Cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ── Prepayment settlement dialog (shown when editing a booking with requires_capture) ── -->
    <v-dialog v-if="!currentBooking" v-model="dialog_prepayment_settlement" max-width="400" persistent>
      <v-card>
        <v-card-title class="pb-1">
          <v-icon left :color="prepayment_action === 'cancel' ? 'info' : 'warning'">
            {{ prepayment_action === 'cancel' ? 'mdi-cash-remove' : 'mdi-cash-check' }}
          </v-icon>
          <span v-if="prepayment_action === 'cancel'">{{ $t(page+'.Authorization Released') }}</span>
          <span v-else-if="prepayment_action === 'refund'">{{ $t(page+'.Payment Refunded') }}</span>
          <span v-else>{{ $t(page+'.Prepayment Captured') }}</span>
        </v-card-title>
        <v-divider class="fw"></v-divider>
        <v-card-text class="pt-4 pb-2">

          <!-- Loading -->
          
          <div v-if="prepayment_loading" class="d-flex align-center">
              <v-progress-linear
              :value="100 - cancelSuccessProgress"
              color="success"
              height="4"
              rounded
              class="mt-2"
            />
          </div>
          

          <!-- Success: authorization cancelled (no charge) -->
          <v-alert
            v-if="prepayment_done && prepayment_action === 'cancel'"
            type="info" dense outlined class="mb-0"
            icon="mdi-cash-remove"
          >
            {{ $t(page+'.Your authorized hold of') }}
            <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
            {{ $t(page+'.has been released No charge applied') }}.
          </v-alert>

          <!-- Success: authorization refunded (no charge) -->
          <v-alert
            v-if="prepayment_done && prepayment_action === 'refund'"
            type="info" dense outlined class="mb-0"
            icon="mdi-cash-remove"
          >
            {{ $t(page+'.Your payment of') }}
            <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
            {{ $t(page+'.has been refunded No charge applied') }}.
          </v-alert>          

          <!-- Success: authorization captured (charged) -->
          <v-alert
            v-else-if="prepayment_done && prepayment_action === 'capture'"
            type="warning" dense outlined class="mb-0"
            icon="mdi-cash-check"
          >
            {{ $t(page+'.Your prepayment of') }}
            <strong>€ {{ Number(currentBooking && currentBooking.paymentAmount).toFixed(2) }}</strong>
            {{ $t(page+'.has been charged as a late-change fee') }}.
            {{ $t(page+'.The reservation was less than') }}
            <strong>{{ settings.options.stripeCancelAuthorizationHours }}</strong>
            {{ $t(page+'.hours away') }}.
          </v-alert>

          <!-- Error -->
          <v-alert v-else-if="prepayment_error" type="error" dense outlined class="mb-0">
            {{ prepayment_error }}
          </v-alert>

        </v-card-text>
        <v-card-actions class="justify-center pb-4" v-if="!prepayment_loading">
          <v-btn @click="dialog_prepayment_settlement = false">
            <v-icon small class="mr-1">mdi-check</v-icon>
            {{ $t(page+'.OK') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ── Cancellation success dialog ── -->
    <v-dialog v-model="dialog_cancel_success" max-width="400" persistent>
      <v-card>
        <v-card-title class="text-h6 pb-1">
          {{ $t(page+'.Summary') }}
        </v-card-title>
        <v-card-text class="pt-2 pb-4">

          <!-- Step 1: Cancel booking -->
          <div class="d-flex align-center py-2">
            <div class="flex-grow-1">
              <span class="text-body-1">{{ cancel_booking_done ? $t(page+'.Reservation Cancelled') : $t(page+'.Cancelling Reservation') + '...' }}</span>
              <v-progress-linear
                v-if="!cancel_booking_done"
                indeterminate color="primary" height="3" rounded class="mt-1"
              />
            </div>
            <v-icon v-if="cancel_booking_done" color="success" class="ml-4">mdi-checkbox-marked-circle</v-icon>
          </div>

          <!-- Step 2: Stripe payment settlement (only if applicable) -->
          <template v-if="cancel_booking_done && cancel_has_payment">
            <v-divider class="my-1 fw"></v-divider>
            <div class="d-flex align-center py-2">
              <div class="flex-grow-1">
                <span class="text-body-1">
                  <template v-if="cancel_settling">{{ $t(page+'.Processing Deposit') + '...' }}</template>
                  <template v-else-if="cancel_settle_action === 'cancel'">{{ $t(page+'.Deposit Cancelled') }}</template>
                  <template v-else-if="cancel_settle_action === 'capture'">{{ $t(page+'.Deposit Captured') }}</template>
                  <template v-else>{{ $t(page+'.Processing Deposit') + '...' }}</template>
                </span>
                <v-progress-linear
                  v-if="cancel_settling"
                  indeterminate color="warning" height="3" rounded class="mt-1"
                />
              </div>
              <v-icon
                v-if="cancel_settled"
                :color="cancel_settle_action === 'capture' ? 'warning' : 'success'"
                class="ml-4"
              >mdi-checkbox-marked-circle</v-icon>
            </div>
          </template>

          <!-- Step 3: Countdown + Close button -->
          <template v-if="cancel_booking_done && (!cancel_has_payment || cancel_settled)">
            <v-divider class="mt-2 mb-3 fw"></v-divider>
            <v-progress-linear
              :value="100 - cancelSuccessProgress"
              color="success" height="4" rounded
            />
            <div class="text-center mt-3">
              <v-btn text small @click="closeCancelSuccess">{{ $t(page+'.Close') || 'Close' }}</v-btn>
            </div>
          </template>

        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
  <v-dialog v-model="dialog_advertiser" fullscreen transition="fade-transition">
    <v-card tile class="advertiser-iframe-card">
      <v-btn icon class="advertiser-iframe-close" @click="dialog_advertiser = false; advertiserIframeUrl = null">
        <v-icon size="28" color="white">mdi-close</v-icon>
      </v-btn>
      <iframe v-if="advertiserIframeUrl" :src="advertiserIframeUrl" frameborder="0" class="advertiser-iframe" allow="fullscreen"></iframe>
    </v-card>
  </v-dialog>  
</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Booking",
  
  props: {
    customerId: {
      type: String,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    initialOpenBookings: {
      type: Array,
      default: null
    },
    advertisers: {
      type: Array,
      default: null
    }
  },
  
  data() {
    return {
      page: "Booking",
      stepper:2,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      WLH:window.location.hostname,
      dialog_warning_before_booking:false,
      dialog_booked:false,
      dialog_error_booked:false,
      dialog_connection_error:false,
      dialog_already_exists:false,
      dialog_optIn:false,
      dialog_optIn_tos:false,
      dialog_waitingListTime:false,
      dialog_stripe:false,
      dialog_wa_failed:false,
      advertiserCarousel: 0,
      dialog_advertiser: false,
      advertiserIframeUrl: null,      
      dialog_more_than:false,
      dialog_readonly_phone: false,
      dialog_showMealInfo:false,
      loading:false,
      loading_book:false,
      open_confirm_dialog:false,
      loading_verifyNumber:false,
      loading_resend:false,
      noProceed_messages:[],
      overbooking:0,
      covers:null,
      stripe:null, // Stripe.js instance
      stripeElements:null, // Stripe Elements instance
      stripePaymentElement:null, // Payment Element (mounted in dialog)
      stripePaymentRequest:null, // Express Checkout Element instance (Google Pay)
      stripePaymentIntentId:null, // Payment Intent ID
      stripeClientSecret:null, // Client secret for confirmCardPayment
      stripeWalletAvailable:false, // Whether wallet payment is available
      stripeLoading:false, // Stripe loading state
      stripePaid:false, // Stripe payment success
      stripeError:false, // Stripe payment error
      stripeCancel:false, // Stripe payment cancelled
      stripeSuccessProgress: 0, // auto-advance progress (0-100) on step 14
      _stripeSuccessTimer: null,
      stripeExtendedAuthRequested: false,   // true when PI was created with request_extended_authorization
      stripeEventTimestamp: null,           // Unix timestamp of booking event (for capture_before check)
      stripeExtendedAuthFallbackActive: false, // true while rebuilding the dialog after fallback
      stripeApplicationFeeAmount: 0,        // application_fee_amount in cents from PI creation response
      existingBookings:null,
      existingTime:null,
      freeTables:[],
      freeeTable:null,
      createdDate:null,
      continue_message:null,
      date:null,//new Date().toISOString().substring(0,10),
      today:new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000 )).toISOString().split("T")[0],
      slotId:null,
      locationId:null,
      hallId:null,
      time:null,
      area:null,
      newUser:0,
      optIn:0,
      firstName:null,
      lastName:null,
      phone:null,
      countryCode:39,
      remarks:null,
      origin:null,
      locale:null,   
      activeOptions:null,	
      bottom_navigation:1,
      errorPhone:'',
      errorPhone_status:1,
      bookingId:null,
      authenticated:0,
      slot:null,
      locations:null,
      tableSplittingMessage:null,
      tablesByCovers:[],
      focus:null,
      requestsCopy:null,
      checkedPhone:null,
      bookingRslt:null,
      bookableDays:null,
      openBookings:null,
      booking:{locationId:null,hallId:null,bookingId:null,countryCode:39,covers:null,children:null,date:null,firstName:null,lastName:null,requests:[],foodStyles:[],phone:null,slotId:null,time:null,optIn:false,gender:null,postalCode:null,waitingListTime:null,WAMessageId:null,waiting:0},
      booking_clone:null,
      slides:[],
      halls:null,
      requests:[],
      foodStyles:[],
      foodStylesCopy:null,
      faqs:null,
      menuPicker: null,
      menuBirthdate: false,
      snackbar:{active:false,color:'success',text:''},
      uu:null,
      WAVerificationStarted:false,
      otpSent: false,
      otpResendCount: 0,
      otpPrivacyDialog: false,
      otpSending: false,
      otp: null,
      otpError: false,
      otpResendCooldown: 0,
      _otpCooldownTimer: null,
      paymentRequired:false,
      tryToGetFreeSlots:false,
      WAStatusCode:null,
      WAStatus:null,
      successfulBooking:false,
      forceTableAllocation:false,
      expired:null,
      mobilePhoneRegex:null,
      checkingWADelivered:0,
      resendMessageEnabled:true,
      WADelivered:0,
      voxNumber:false,
      bookingId_WA:null,
      attempts_WA:0,
      privacyClicked:0,
      minScore:null,
      currentBooking:null,
      isCoverChanged:0,
      mainTab:null,
      checkResendWA:false,
      resendPolicy:false,
      hasAuthenticated: false,
      stripeSessionId: null,
      stripePaymentData: null,
      childrenQuestion: null,  // null=unanswered, true=yes (show count), false=no (0 set)
      ob:null,
      url:null,
      dialog_cancel_booking: false,
      loading_cancel: false,
      // ── prepayment settlement (on edit) ──────────────────────────────────
      dialog_prepayment_settlement: false,
      prepayment_action: null,     // 'capture' | 'cancel' — determined server-side
      prepayment_loading: false,
      prepayment_done: false,
      prepayment_error: null,
      // ── cancel success dialog ────────────────────────────────────────────
      dialog_cancel_success: false,
      cancel_booking_done: false,   // booking cancel API succeeded
      cancel_has_payment: false,    // whether there is a Stripe payment to settle
      cancel_settling: false,       // true while Stripe settle call is in-flight
      cancel_settled: false,        // true once settle is done (or no payment to settle)
      cancel_settle_action: null,   // 'cancel' | 'capture' | null
      cancelSuccessProgress: 0,     // 0-100 countdown for auto-close (10s)
      _cancelSuccessTimer: null,
      //isEditingExistingBooking: false,  // true when editing an existing booking (step 2)
      forceManualConfirmation: false,  // true when editing and selected slot is at capacity but edit is allowed
      reservationCounts:null,
      disableSameDayDirectBooking:null,
      showSameDayDialog: false,

      //CONTACTS API
      isSupported_contacts: null,
      multiple_contacts: true,
      availableProperties_contacts: ['name', 'email', 'tel', 'address', 'icon'],
      selectedProperties_contacts: ['name', 'tel', 'icon'],
      contacts: [],
      contactStep: 0,
      selectedTemplate: null,
      contactCustomSentence: '',
      contactsSendStatus: [],
      contactsSending: false,
      contactsPollingTimer: null,
      contactsPolling: false,

      deferredPrompt: null,
      showInstallButton: false,      
    }
  },
  
  computed: {
    ...mapGetters(['settings', 'countries']),
    canProceedToConsent() {
      const O = this.settings?.options || {};
      const b = this.booking || {};
      
      // Basic Presence
      const hasPhone = Boolean(b.phone);
      const hasFirstName = Boolean(b.firstName);
      const hasLastName = Boolean(b.lastName);
      
      // Phone Validation
      const phoneValid = this.is_ValidPhone(b.phone, b.countryCode) === true;
      
      // Email Validation
      const emailValid = O.emailRequired === '1' 
        ? (Boolean(b.email) && /.+@.+\..+/.test(b.email))
        : true;
      
      // Birthdate Validation
      const birthdateValid = O.birthdateRequired === '1'
        ? (Boolean(b.birthdate) && !isNaN(Date.parse(b.birthdate)))
        : true;
      
      // Postal Code Validation (Italy = 39)
      const isItaly = Number(b.countryCode) === 39;
      const postalCodeStr = String(b.postalCode || '');
      const postalCodeValid = (O.postalCodeRequired === '1' && isItaly) 
        ? /^\d{5}$/.test(postalCodeStr)
        : true;
      
      // OTP Validation (Safe String conversion)
      const otpClean = String(b.otp || '').replace(/-/g, '');
      const OTPValid = !this.otpSent || (this.otpSent && otpClean.length === 9);

      return Boolean(
        hasPhone && 
        hasFirstName && 
        hasLastName && 
        phoneValid && 
        emailValid && 
        birthdateValid && 
        postalCodeValid && 
        OTPValid
      );
    },    
      reservationCountForBooking() {
        if (!this.reservationCounts || !this.reservationCounts.length) return 0;

        var found;
        if (this.booking.date) {
          found = this.reservationCounts.find(r => r.date == this.booking.date);
        } else {
          found = this.reservationCounts[0];
        }

        return found ? found.reservationCount : 0; // always a number
      },
      isDev() {
        return localStorage.getItem('dev') !== '1234'? false : true
      },
      isDevv() {
        return localStorage.getItem('devv') !== '4321'? false : true
      },      
      isDesktop() {
        return this.$vuetify.breakpoint.mdAndUp
      },
      carouselHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 90
          case 'sm': return 120
          case 'md': return 160
          case 'lg': return 200
          case 'xl': return 240
          default:   return 90
        }
      },      
      daysUntilReservation: function() {
        if (!this.booking.date) return 0;
        const today = new Date();
        const reservationDate = new Date(this.booking.date);
        const diffTime = reservationDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        //console.log(1791,diffDays,diffTime,reservationDate,today)
        return diffDays;
      },
      // Precise hours until booking (uses time if available, falls back to midnight)
      hoursUntilReservation: function() {
        if (!this.booking.date) return 0;
        const timeStr = (this.booking.time || '00:00').substring(0, 5);
        const eventMs = new Date(`${this.booking.date}T${timeStr}:00`).getTime();
        return (eventMs - Date.now()) / (1000 * 60 * 60);
      },
      // Formatted deadline by which customer can cancel for free (event minus threshold)
      cancelDeadlineText: function() {
        if (!this.booking.date) return '';
        const covers = (parseInt(this.booking.covers) || 0) + (parseInt(this.booking.children) || 0);
        const threshold = (parseFloat(this.settings.options.stripeCancelAuthorizationHours) || 4) * (covers || 1);
        const timeStr  = (this.booking.time || '00:00').substring(0, 5);
        const eventMs  = new Date(`${this.booking.date}T${timeStr}:00`).getTime();
        const deadline = new Date(eventMs - threshold * 3600 * 1000);
        const locale   = this.settings.locale || 'it-IT';
        return this.formatDate(deadline,'WdMhi') 
        /*
        new Intl.DateTimeFormat(locale, {
          weekday: 'long', day: 'numeric', month: 'long',
          hour: '2-digit', minute: '2-digit'
        }).format(deadline);*/
      },
      // True when the free-cancellation window has already closed (deadline is in the past)
      cancelDeadlinePassed: function() {
        if (!this.booking.date) return false;
        const covers = (parseInt(this.booking.covers) || 0) + (parseInt(this.booking.children) || 0);
        const threshold = (parseFloat(this.settings.options.stripeCancelAuthorizationHours) || 4) * (covers || 1);
        return this.hoursUntilReservation < threshold;
      },
      // Returns per-DoW max children from highchairsByDoW; falls back to maxBookableChildren
      maxBookableChildrenForDate() {
        const dow = this.settings?.options?.highchairsByDoW;
        if (dow) {
          const date = this.booking?.date || new Date().toISOString().split('T')[0];
          const dayIndex = (new Date(date + 'T00:00:00').getDay() + 6) % 7; // Mon=0 … Sun=6
          const parts = String(dow).split(',');
          if (parts[dayIndex] !== undefined) return parts[dayIndex].trim();
        }
        return this.settings?.options?.maxBookableChildren ?? '0';
      },
      contactTemplates() {
        return [
          { key: 'funny',         label: 'Simpatico',      icon: 'mdi-emoticon-happy-outline' },
          { key: 'serious',       label: 'Formale',        icon: 'mdi-tie' },
          { key: 'institutional', label: 'Istituzionale',  icon: 'mdi-office-building-outline' },
        ]
      },
      contactMessagePreview() {
        if (!this.selectedTemplate || !this.contacts.length) return ''
        const name  = this.getContactName(this.contacts[0])
        const date  = this.booking?.date ? this.formatDate(this.booking.date, 'wdM') : '…'
        const time  = this.booking?.time || '…'
        const rest  = this.settings?.options?.restaurantName || this.settings?.options?.name || ''
        const extra = this.contactCustomSentence ? `\n\n${this.contactCustomSentence}` : ''
        const address = this.settings?.options?.restaurantAddress || this.settings?.options?.infopage_address || ''
        return {
          funny:         `🎉 Ehi ${name}! Indovina chi prenota? Io! 😄\nTi aspetto il ${date} alle ${time} da ${rest}.\nCi vieni? 🍽️${extra}`,
          serious:       `Caro/a ${name},\nho il piacere di invitarti a cena il\n${date}\nalle ore ${time}\npresso ${rest}\n ${address}.\n\nTi aspetto!${extra}`,
          institutional: `Gentile ${name},\nla informo che il ${date} alle ore ${time} sarà ospite presso ${rest}.\nLa attendiamo con piacere.${extra}`,
        }[this.selectedTemplate] || ''
      },
      // Full field list for step 19 result screen — shows all fields, marks which ones changed
      bookingFullDiff() {
        const cb = this.currentBooking
        const b  = this.booking
        if (!cb) return []
        const locale = this.settings.locale || 'it-IT'
        const fmt = (d) => d ? this.formatDate(d,'wdM'):'';//new Intl.DateTimeFormat(locale, { weekday:'short', day:'numeric', month:'short' }).format(new Date(d)) : ''
        const oldTime = (cb.time || '').substring(0, 5)
        const newTime = (b.time  || '').substring(0, 5)
        const oldCovers   = parseInt(cb.covers)   || 0
        const newCovers   = parseInt(b.covers)    || 0
        const oldChildren = parseInt(cb.children) || 0
        const newChildren = parseInt(b.children)  || 0
        const oldLocation = cb.locationName || ''
        const newLocationObj = this.locations && this.locations.find(l => l.locationId == b.locationId)
        const newLocation = newLocationObj ? (newLocationObj.name || newLocationObj.nameDB) : (b.locationName || '')
        return [
          { key: 'Date',     old: fmt(cb.date), now: fmt(b.date), changed: b.date !== cb.date },
          { key: 'Time',     old: oldTime,      now: newTime,      changed: oldTime !== newTime },
          { key: 'Covers',   old: oldCovers,    now: newCovers,    changed: newCovers !== oldCovers },
          { key: 'Children', old: oldChildren,  now: newChildren,  changed: newChildren !== oldChildren },
          { key: 'Area',     old: oldLocation,  now: newLocation,  changed: (b.locationId || null) !== (cb.locationId || null) },
        ]
      },
  },
created() {
    // 1. Listen for the events when the component is created
    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', this.handleAppInstalled);
  },
  watch: {
    stepper(val) {
      if (val === 13) {
        // Start auto-advance: 3.0 s total, tick every 30 ms (+1 point each tick)
        this.stripeSuccessProgress = 0
        this._stripeSuccessTimer = setInterval(() => {
          this.stripeSuccessProgress += 1
          if (this.stripeSuccessProgress >= 100) {
            clearInterval(this._stripeSuccessTimer)
            this._stripeSuccessTimer = null
            this.closeStripeResult()
          }
        }, 30)
      } else {
        // Clear timer when leaving step 14 (e.g. user navigates back)
        if (this._stripeSuccessTimer) {
          clearInterval(this._stripeSuccessTimer)
          this._stripeSuccessTimer = null
        }
        this.stripeSuccessProgress = 0
      }/*
    if (
      val === 8 &&
      !this.otpSent &&
      !this.otpSending &&
      this.booking.phone &&
      this.is_ValidPhone(this.booking.phone, this.booking.countryCode) === true &&
      this.customer && this.customer.validated !== 1
    )
    {
      this.$nextTick(() => {
        if (typeof this.sendOtpWA === 'function') this.sendOtpWA()
      })
    }*/      
  },
  isActive: {
    immediate: true,
    handler(newVal) {
      if (!newVal) return
      if (this.hasAuthenticated) {
        if (this.openBookings && this.openBookings.length) {
          this.stepper = 30
        }
        return
      }
      this.maybeShowManageReservations(this.initialOpenBookings)
      this.getBookingDate()
    }
  },

    // NEW: catches the desktop-docked case, where BookingTab is mounted
    // with is-active=true before InfoTab has finished loading openBookings.
    initialOpenBookings(val) {
      this.maybeShowManageReservations(val)
    },
    menuBirthdate (val) {
      val && setTimeout(() => (this.$refs.birthdate.activePicker = 'YEAR'))
    },
    'booking.locationId'(val) {
      this.tryToGetFreeSlots=(!val)?false:this.tryToGetFreeSlots;
    },
    'booking.phone'(val) {
      // Auto-send WA OTP only for new customers (WAVerification === 0) with valid phone
      if (
        this.is_ValidPhone(val, this.booking.countryCode) === true &&
        !this.otpSent &&
        !this.otpSending &&
        //!this.booking.bookingId &&
        this.customer && this.customer.validated !== 1 
      ) {
        this.otpResendCount = 0  // reset counter for new phone
        this.$nextTick(() => {
          if (typeof this.sendOtpWA === 'function') this.sendOtpWA()
        })
      }
    },
    'booking.countryCode'() {
      // Reset OTP state when country code changes
      if (this.otpSent) {
        this.otpSent = false
        this.otp = null
        this.otpError = false
      }
    },    
  },

  mounted() {
    // No need to check for Stripe redirects - payment happens in dialog/popup
    this.customerId=localStorage.getItem('customerId'),
    this.checkSupport()
  },
  beforeDestroy() {
    if (this.contactsPollingTimer) clearInterval(this.contactsPollingTimer)
    // Clean up listeners if the component is ever destroyed
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
    window.removeEventListener('appinstalled', this.handleAppInstalled);    
  },
  methods: {
    handleBeforeInstallPrompt(e) {
      // Prevent the default mini-infobar
      e.preventDefault();
      // Stash the event so it can be triggered later
      this.deferredPrompt = e;
      // Show the Vuetify button
      this.showInstallButton = true;
    },
    async promptInstall() {
      if (!this.deferredPrompt) return;

      // Show the native browser install prompt
      this.deferredPrompt.prompt();

      // Wait for the user's choice
      const { outcome } = await this.deferredPrompt.userChoice;
      console.log(`User response to install prompt: ${outcome}`);

      // Clear the prompt and hide the button regardless of their choice
      // (If they dismiss it, the browser won't let us prompt again immediately anyway)
      this.deferredPrompt = null;
      this.showInstallButton = false;
    },
    handleAppInstalled() {
      // Hide the button once the app is successfully installed
      this.showInstallButton = false;
      this.deferredPrompt = null;
      console.log('PWA was installed');
    },    
    /**
     * Check if navigator.contacts is available in the current browser engine
     */
    async checkSupport() {
      const supported = 'contacts' in navigator && 'ContactsManager' in window;
      
      if (supported) {
        try {
          // Fetch exact supported properties by this browser (optional safety check)
          const props = await navigator.contacts.getProperties();
          this.availableProperties_contacts = props;
          this.isSupported_contacts = true;
        } catch (err) {
          // If getProperties fail, basic feature detection passed
          this.isSupported_contacts = true;
        }
      } else {
        this.isSupported_contacts = false;
      }
    },

    /**
     * Trigger native Contact Picker overlay
     */
    async selectContacts() {
      if (!this.isSupported_contacts) return;

      this.loading = true;
      try {
        const options = { multiple: this.multiple_contacts };
        
        // Native Contact Picker API execution
        const selectedContacts = await navigator.contacts.select(
          this.selectedProperties_contacts, 
          options
        );

        this.contacts = selectedContacts;
      } catch (err) {
        // Exception handles user cancellations (AbortError) or permission issues
        if (err.name !== 'AbortError') {
          this.errorMessage = err.message || "Failed to select contacts.";
          this.snackbar = true;
        }
      } finally {
        this.loading = false;
      }
    },

    getContactName(contact) {
      if (contact.name && contact.name.length > 0) return contact.name[0];
      return 'Unnamed Contact';
    },

    normalizePhone(tel, defaultCountryCode) {
      let n = String(tel || '').replace(/[\s+\-().]/g, '')
      if (n.startsWith('00')) n = n.slice(2)
      else if (n.startsWith('0') && n.length <= 11)
        n = String(defaultCountryCode || '39').replace(/\D/g, '') + n.slice(1)
      else if (n.length <= 10 && defaultCountryCode)
        n = String(defaultCountryCode).replace(/\D/g, '') + n
      return n
    },

    contactStatusColor(status) {
      return ({ sent:'blue', delivered:'teal', read:'success', failed:'error', sending:'grey', pending:'grey' })[status] || 'grey'
    },
    contactStatusIcon(status) {
      return ({ sent:'mdi-check', delivered:'mdi-check-all', read:'mdi-check-all', failed:'mdi-close-circle', sending:'mdi-clock-outline', pending:'mdi-clock-outline' })[status] || 'mdi-clock-outline'
    },
    contactStatusLabel(status) {
      return ({ sent:'Inviato', delivered:'Consegnato', read:'Letto', failed:'Fallito', sending:'Invio…', pending:'In attesa' })[status] || '…'
    },

    async sendContactsInvite() {
      if (!this.selectedTemplate || !this.contacts.length) return
      const cc = this.booking?.countryCode || 39
      const normalized = this.contacts
        .filter(c => c.tel && c.tel.length)
        .map(c => ({
          name:   this.getContactName(c),
          mobile: this.normalizePhone(c.tel[0], cc),
          email:  (c.email && c.email[0]) || null,
          icon:   (c.icon  && c.icon[0])  || null,
        }))
      if (!normalized.length) return

      this.contactsSendStatus = normalized.map(c => ({ name: c.name, phone: c.mobile, status: 'sending' }))
      this.contactsSending = true
      this.contactStep = 2

      try {
        console.log(2821,this.settings?.brand, this.settings?.options?.infopage_address,this.customer)
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'saveAndSendContacts',
          payload: {
            customerId:     this.customer.customerId,
            bookingId:      this.bookingId_WA,//this.booking.bookingId,
            contacts:       normalized,
            template:       this.selectedTemplate,
            customSentence: this.contactCustomSentence,
            date:           this.booking.date,
            time:           this.booking.time,
            restaurantName: this.settings?.brand  + ' - ' + this.settings?.options?.infopage_address ,
            senderName:     this.customer.firstName + ' '+ this.customer.lastName,  
            locale:         this.settings?.locale || 'it',
            logoWA:         this.settings?.options?.logoWA || null,
          }
        })
        if (res.data.errorid === '0' && Array.isArray(res.data.payloads)) {
          this.contactsSendStatus = res.data.payloads.map(s => ({
            name: s.name, phone: s.phone, status: s.status, messageId: s.messageId || null
          }))
        }
      } catch(e) {
        console.error('sendContactsInvite failed', e)
        this.contactsSendStatus = this.contactsSendStatus.map(s => ({ ...s, status: 'failed' }))
      } finally {
        this.contactsSending = false
      }
      this.startContactsPolling()
    },

    simulateContacts() {
      this.contacts = [
        { name: ['Mario Rossi'],  tel: ['+39 320 302 38 32'], email: [], icon: [] },
        { name: ['Anna Bianchi'], tel: ['3505992731'],    email: [], icon: [] },
      ]
    },

    startContactsPolling() {
      let elapsed = 0
      this.contactsPolling = true
      if (this.contactsPollingTimer) clearInterval(this.contactsPollingTimer)
      this.contactsPollingTimer = setInterval(async () => {
        elapsed += 2000
        try {
          const res = await this.$http.post('/booking/booking_stepper.php', {
            action: 'getContactsStatus',
            payload: {
              bookingId: this.bookingId_WA,
              contacts: this.contactsSendStatus.map(s => ({ phone: s.phone, messageId: s.messageId }))
            }
          })
          if (res.data.errorid === '0' && Array.isArray(res.data.payloads)) {
            // Match by messageId when available, fall back to phone
            this.contactsSendStatus = this.contactsSendStatus.map(cs => {
              const found = res.data.payloads.find(s =>
                cs.messageId && s.messageId ? s.messageId === cs.messageId : s.phone === cs.phone
              )
              return found ? { ...cs, status: found.status } : cs
            })
          }
        } catch { /* ignore polling errors */ }
        const allDone = this.contactsSendStatus.every(s => ['delivered','read','failed'].includes(s.status))
        if (elapsed >= 16000 || allDone) { clearInterval(this.contactsPollingTimer); this.contactsPolling = false }
      }, 2000)
    },
    //////
    maybeShowManageReservations(list) {
      if (list && list.length && this.stepper === 2 && !this.successfulBooking) {
        this.openBookings = list
        this.stepper = 30
        return true
      }
      return false
    },

    toggleOption(field, id) {
      if (!this.booking.covers) return // respects your existing :disabled logic
      const arr = this.booking[field]
      const idx = arr.indexOf(id)
      if (idx === -1) {
        arr.push(id)
      } else {
        arr.splice(idx, 1)
      }
    },

    /**
     * Authenticate and load initial restaurant data
     */
    reloadPage() {
      window.location.reload()
    },

    /**
     * Returns the availability state for a slot button:
     *   disabled   — whether the button should be disabled
     *   badgeClass — Vuetify colour class for the availability badge
     *   label      — translated text for the badge
     */

    showMealInfo(ft,item)
    {
      console.log(2123,item,ft.duration,ft.prepayment,this.booking.slotId,ft,this.booking)
      this.freeTable={...ft};
      this.freeTable.item=item;
      this.dialog_showMealInfo=!this.dialog_showMealInfo;
    },
    getSlotFlags(ft) {
      const mask = this.settings.options.manuallyConfirmNotCompliant / 1
      const unassigned   = !ft.assigned && ft.unassigned
      const notCompliant = ft.notCompliant && ((ft.notCompliant & mask) !== ft.notCompliant) ? true : false
      const needsWaiting = unassigned || notCompliant
      return { unassigned, notCompliant, needsWaiting }
    },

    slotState(ft) {
      const wl = this.settings.options.manageWaitingList
      const { needsWaiting } = this.getSlotFlags(ft)

      let badgeClass, label, disabled

      if (needsWaiting) {
        if (wl === '1') {
          badgeClass = 'warning'
          label      = this.$t(this.page + '.Waiting List')
          disabled   = false
        } else {
          badgeClass = 'error'
          label      = this.$t(this.page + '.Sold Out')
          disabled   = true
        }
      } else {
        badgeClass = 'success'
        label      = this.$t(this.page + '.Available')
        disabled   = false
      }

      // ── Manual confirmation override ────────────────────────────────────────
      if (ft.manualConfirmation&&!ft.hasBadRating) {
        badgeClass = 'success'
        label      = this.$t(this.page + '.Available')
        disabled   = false
      }
      // ─────────────────────────────────────────────────────────────────────────

      return { disabled, badgeClass, label }
    },

    processSlot(i)
    {
      console.log(2918, i)
      this.booking.slotId=null;
      this.booking.time=i.name;
      var deposit=i.prepayment;
      var forcedDeposit=this.bookableDays.find(d=>d.date==this.booking.date).deposit;

      if ((i.prepayment&&(
                          (this.booking.covers+this.booking.children)>=this.settings.options.depositMinCovers
                          &&(
                            this.customer.arrivedCount<parseInt(this.settings.options.depositOnlyCustomersWithLessThanBooking)||this.customer.noShowYeld>parseInt(this.settings.options.depositOnlyCustomersWithLessThanNoShow)
                          )
                        ))||forcedDeposit
      )
      {
          this.paymentRequired=true;
          this.booking.forcedDeposit=forcedDeposit;
          this.booking.deposit=forcedDeposit?forcedDeposit:deposit;
          var amount=((forcedDeposit?forcedDeposit:deposit)*parseInt(this.booking.covers)).toFixed(2)
          this.booking.prepaidAmount=amount;
      }
      else
      {
        this.paymentRequired=false
        this.booking.prepaidAmount=null
      }
      this.booking.waiting=0;
      this.forceManualConfirmation = false;

      const wl = this.settings.options.manageWaitingList
      const { needsWaiting } = this.getSlotFlags(i)

      // Mirrors slotState: this only fires for the "Waiting List" case (warning/clickable).
      // The "Sold Out" case (needsWaiting && wl!=='1') is disabled in the UI and never reaches here.
      if (needsWaiting && wl === '1' && !this.booking.slotId && !i.manualConfirmation)
      {
        this.booking.waiting=1;
        if(this.currentBooking)
        {
          const oldTotal = (parseInt(this.currentBooking.covers) || 0) + (parseInt(this.currentBooking.children) || 0)
          const newTotal = (parseInt(this.booking.covers)        || 0) + (parseInt(this.booking.children)        || 0)
          const sameDate     = this.booking.date       === this.currentBooking.date
          const sameLocation = (this.booking.locationId || null) === (this.currentBooking.locationId || null)
          const sameSlot = this.booking.slotId === this.currentBooking.slotId
          const onlyCoversReduced = newTotal < oldTotal && sameDate && sameLocation && sameSlot
          console.log(3102,oldTotal,newTotal,sameDate,sameLocation,onlyCoversReduced)
          if (onlyCoversReduced) {
            this.booking.waiting = 0
            //this.forceManualConfirmation = true
          } else {
            this.forceManualConfirmation = false
            //this.booking.waiting = 0
          }
          this.booking.waitingListTime=1;
          this.booking.unassignedBookings=i.unassignedBookings;
        }
        else
        {
          //this.dialog_waitingListTime=true;
          //this.forceManualConfirmation = false
        }
      }
    },    

    formatDate(date, type) {
      var locale = this.settings?.locale || navigator?.language || 'it-IT';
      
      if (!date) return '';
      var d = new Date(date);

      // Map each custom code character to its Intl.DateTimeFormat option
      var optionMap = {
        // Weekday
        'w': { weekday: 'short' },
        'W': { weekday: 'long' },

        // Day
        'd': { day: '2-digit' },

        // Month
        'm': { month: '2-digit' },
        'M': { month: 'short' },
        'N': { month: 'long' },

        // Year
        'y': { year: '2-digit' },
        'Y': { year: 'numeric' },

        // Time
        'h': { hour: '2-digit', hour12: false },
        'H': { hour: '2-digit', hour12: true },
        'i': { minute: '2-digit' },
        's': { second: '2-digit' },
        'z': { fractionalSecondDigits: 3 }
      };

      // Build options dynamically from the characters in `type`
      var options = {};
      if (type) {
        for (var i = 0; i < type.length; i++) {
          var char = type[i];
          if (optionMap[char]) {
            Object.assign(options, optionMap[char]);
          }
        }
      }

      // Fallback to default format if type is empty or invalid
      if (Object.keys(options).length === 0) {
        options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      }

      return new Intl.DateTimeFormat(locale, options).format(d);
    },
    /*
    formatHeader(date) {
      var locale=this.settings.locale || navigator.language || 'en-US';
      const d = new Date(date + 'T00:00:00');
      const formatted = new Intl.DateTimeFormat(locale, { 
        month: 'long', 
        year: 'numeric' 
      }).format(d);
      
      // Capitalize the first letter
      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    },
    */

    async getBookingDate() {
      this.loading = true
      this.booking.origin = this.$route.path ? this.$route.path : '/db';
      
      try {
        // Get route parameters
        this.bookingId = this.$route.query.p
        if (this.$route.query && this.$route.query.q) {
          this.sessionId = this.$route.query.q.split('/?')[0]
        }
        
        // Get customerId from localStorage (fallback to prop)
        const customerId = localStorage.getItem('customerId') || this.customerId
        const hostname = window.location.hostname
        
        // ✅ Axios interceptor automatically adds JWT and CSRF to headers
        // No need to manually add headers - interceptor handles it
        
        // Request payload (clean - no tokens in body)
        const requestBody = {
          action: 'Authenticate',
          payload: {
            customerId: customerId,
            bookingId: this.bookingId,
            hostname: hostname,
            locale: this.settings.locale,
            sessionId: this.sessionId
          }
        }
        
        // Make API call - interceptor will add tokens to headers automatically
        // and update tokens from response headers automatically
        const res = await this.$http.post('/booking/booking_stepper.php', requestBody)
        
        if (res.data.errorid === '0') {
          // ✅ Axios response interceptor already updated JWT and CSRF tokens in sessionStorage
          // No need to manually read headers - interceptor handles it
          
          // Store settings
          sessionStorage.setItem('settings', JSON.stringify(res.data.payloads.settings))
          
          // Update page title
          document.title = res.data.payloads.settings.brand
          
          // Update Vuex store
          this.$store.dispatch('setSettings', res.data.payloads.settings)
          
          // Load restaurant data (booking-related only)
          this.customer = res.data.payloads.customer
          if (this.customer && this.customer.customerId) {
            localStorage.setItem('customerId', this.customer.customerId)
          }
          console.log('customer:',this.customer)
          // Booking-specific data
          this.expired = res.data.payloads.expired || null
          this.requests = res.data.payloads.requests || []
          this.foodStyles = res.data.payloads.foodStyles || []
          this.meals = res.data.payloads.meals || []
          this.locations = res.data.payloads.locations || []
          this.bookableDays = res.data.payloads.bookableDays;
          this.disableSameDayDirectBooking = res.data.payloads.settings.options.disableSameDayDirectBooking || null
          this.mobilePhoneRegex = res.data.payloads.mobilePhoneRegex
          this.reservationCounts = res.data.payloads.reservationCounts || []
          this.ClosedLocationByTables = res.data.payloads.ClosedLocationByTables || []
          // NOTE: FAQs, Menu, and Reviews are now loaded by their respective tab components
          // when user clicks on those tabs (lazy loading pattern)
          // Auto-select if only one option
          if (this.meals.length === 1) {
            this.booking.mealId = this.meals[0].mealId
          }
          
          if (this.locations.length === 1) {
            this.booking.locationId = this.locations[0].locationId
          }
          
          // Load existing booking if present
          if (this.customer) {
            // Pre-fill with customer data
            Object.assign(this.booking, this.customer)
          }

          // openBookings comes from IdentifyAccount (InfoTab), NOT from Authenticate.
          // They are passed in via the initialOpenBookings prop and handled in the isActive watcher.

          if (res.data.payloads.voxPhoneNumber)
          {
            this.booking.phone=res.data.payloads.voxPhoneNumber.phone;
            this.booking.countryCode=res.data.payloads.voxPhoneNumber.countryCode;
            //this.VMVerification=true;
            this.voxNumber=true;
          }          
          
          // Mark as authenticated
          this.hasAuthenticated = true
          this.loading = false
        }
        else
        {
          this.showError('Authentication failed')
          this.loading = false
          this.$router.push('/unknown').catch(() => {});
        }
      } catch (error) {
        console.error('Authentication error:', error)
        this.showError('Connection error')
        this.loading = false
      }
    },
    /**
     * Load an existing booking from the openBookings list for modification.
     * ob may be a bookingId string or an object with booking details.
     */
    loadNoAlterRefundedReservationDialog(ob)
    {
      this.showRefundedReservationDialog=true;
    },
    loadExistingBooking(ob) {
      //this.isEditingExistingBooking = JSON.parse(JSON.stringify(ob));
      console.log(1705,ob,this.booking,this.locations)
      //this.ob=JSON.parse(JSON.stringify(ob));
      // Save a snapshot of the original booking for the "suggested" highlight (amber buttons)
      this.currentBooking = JSON.parse(JSON.stringify(ob));
      const bookingId = typeof ob === 'string' ? ob : ob.bookingId
      if (bookingId) {
        this.booking.bookingId = bookingId
      }
      // Pre-fill what we know from the open booking object
      if (typeof ob === 'object') {
        if (ob.date)        this.booking.date        = ob.date
        //if (ob.time)        this.booking.time        = ob.time
        //if (ob.covers)      this.booking.covers      = ob.covers
        //if (ob.children)    this.booking.children    = ob.children
        //if (ob.icon)        this.booking.icon    = ob.icon
        if (ob.locationName)    this.booking.locationName    = ob.locationName

        if (ob.slotId)      this.booking.slotId      = ob.slotId
        //if (ob.locationId)  this.booking.locationId  = ob.locationId
        if (ob.countryCode) this.booking.countryCode = ob.countryCode
        if (ob.phone)       this.booking.phone       = ob.phone
        if (ob.firstName)   this.booking.firstName   = ob.firstName
        if (ob.lastName)    this.booking.lastName    = ob.lastName
        if (ob.postalCode)  this.booking.postalCode  = ob.postalCode
        if (ob.email)       this.booking.email       = ob.email
        if (ob.birthdate)   this.booking.birthdate   = ob.birthdate
        if (ob.foodStyles)  this.booking.foodStyles  = [...ob.foodStyles]
        if (ob.requests)    this.booking.requests    = [...ob.requests]
        if (ob.children > 0) this.childrenQuestion = true

      }
      this.openBookings = null
      // If the booking has a pending Stripe authorization, settle it first
      if (ob && ob.stripeStatus === 'requires_capture') {
        //this.checkAndSettlePrepayment()
      }
      // Jump to date picker so user can change the booking
      this.stepper = 2
    },
    deleteExistingBooking(ob) {
      console.log(1960,'delete',ob)
      // Save snapshot for display in confirmation dialog
      this.currentBooking = JSON.parse(JSON.stringify(ob));
      const bookingId = ob.bookingId
      if (bookingId) {
        //this.booking.bookingId = bookingId
      }
      console.log(1967,'delete',bookingId,this.currentBooking)
      // Show confirmation dialog instead of proceeding directly
      this.dialog_cancel_booking = true
    },
    abortCancellation() {
      this.dialog_cancel_booking = false
      this.currentBooking = null
    },
    resetLoadedBooking() {
      this.currentBooking = null
      this.resetForm(1, null)
      this.booking.bookingId = null
    },
    /**
     * When editing an existing booking that has a pending requires_capture payment,
     * determine (server-side) whether to capture or cancel and show an info dialog.
     */
    async checkAndSettlePrepayment(action = null) {
      const cb = this.currentBooking
      //if (!cb || cb.stripeStatus !== 'requires_capture') return
      if (!cb) return

      const threshold   = parseFloat(this.settings.options.stripeCancelAuthorizationHours)*(this.currentBooking.covers+this.currentBooking.children) || 48
      // Determine optimistic action from local data; server will confirm/reject

      this.prepayment_action  = action?action:(cb.hoursUntilReservation >= threshold) ? 'cancel' : 'capture'
      console.log(2183,this.prepayment_action, cb.hoursUntilReservation, threshold,this.currentBooking.covers,this.currentBooking.children)
      this.prepayment_done    = false
      this.prepayment_error   = null
      this.prepayment_loading = true
      this.dialog_prepayment_settlement = true

      try {
        const csrf = sessionStorage.getItem('csrf')
        const res  = await this.$http.post('/booking/settle-payment.php', {
          action: 'settlePayment',
          csrf,
          payload: {
            bookingId:   cb.bookingId,
            action:      this.prepayment_action,
            bookingDate: cb.date        || null,
            bookingTime: (cb.time       || '00:00').substring(0, 5),
          },
        })
        if (res.data && res.data.errorid === '0') {
          this.prepayment_action = res.data.payloads?.action || this.prepayment_action
          this.prepayment_done   = true
        } else {
          this.prepayment_error = res.data?.message || this.$t(this.page + '.Error')
        }
      } catch (e) {
        console.error('settle-payment error', e)
        this.prepayment_error = e?.response?.data?.message || e.message || this.$t(this.page + '.Error')
      } finally {
        this.prepayment_loading = false
      }
    },

    async cancelBooking() {
      this.loading_cancel        = true
      this.cancel_booking_done   = false
      this.cancel_has_payment    = false
      this.cancel_settling       = false
      this.cancel_settled        = false
      this.cancel_settle_action  = null
      this.cancelSuccessProgress = 0
      this.dialog_cancel_success = true

      try {
        const csrf = sessionStorage.getItem('csrf')
        const rsp = await this.updateDB({
          action: 'cancelBooking',
          csrf,
          payload: {
            bookingId: this.currentBooking.bookingId,
            customerId: localStorage.getItem('customerId')
          }
        })

        if (rsp && rsp.errorid === '0') {
          this.cancel_booking_done   = true
          this.dialog_cancel_booking = false

          // Snapshot before clearing currentBooking
          const cb = { ...this.currentBooking }

          // Remove cancelled booking from list
          if (this.openBookings) {
            this.openBookings = this.openBookings.filter(ob => ob.bookingId !== cb.bookingId)
            if (this.openBookings.length === 0) this.openBookings = null
          }
          this.currentBooking = null

          // Settle Stripe authorization if needed
          if (cb.stripeStatus === 'requires_capture') {
            this.cancel_has_payment = true
            this.cancel_settling    = true
            const threshold    = parseFloat(this.settings.options.stripeCancelAuthorizationHours) * (cb.covers + cb.children) || 48
            const settleAction = cb.hoursUntilReservation >= threshold ? 'cancel' : 'capture'
            try {
              const res = await this.$http.post('/booking/settle-payment.php', {
                action:  'settlePayment',
                csrf:    sessionStorage.getItem('csrf'),
                payload: {
                  bookingId:             cb.bookingId,
                  hoursUntilReservation: cb.hoursUntilReservation,
                  threshold,
                  eligibleForCancel:     cb.hoursUntilReservation >= threshold,
                  action:                settleAction,
                  bookingDate:           cb.date || null,
                  bookingTime:           (cb.time || '00:00').substring(0, 5),
                },
              })
              this.cancel_settle_action = res.data?.payloads?.action || settleAction
            } catch (e) {
              console.warn('settle-payment failed:', e)
              this.cancel_settle_action = settleAction
            } finally {
              this.cancel_settling = false
              this.cancel_settled  = true
            }
          }

          // Start 10-second countdown (100ms × 100 ticks)
          this._cancelSuccessTimer = setInterval(() => {
            this.cancelSuccessProgress += 1
            if (this.cancelSuccessProgress >= 100) {
              clearInterval(this._cancelSuccessTimer)
              this._cancelSuccessTimer = null
              this.closeCancelSuccess()
            }
          }, 100)

        } else {
          this.dialog_cancel_success = false
          this.snackbar = { active: true, color: 'error', text: rsp?.message || this.$t(this.page + '.Error') }
        }
      } catch (e) {
        console.error('cancelBooking error', e)
        this.dialog_cancel_success = false
        this.snackbar = { active: true, color: 'error', text: this.$t(this.page + '.Connection error') }
      } finally {
        this.loading_cancel = false
      }
    },

    closeCancelSuccess() {
      if (this._cancelSuccessTimer) {
        clearInterval(this._cancelSuccessTimer)
        this._cancelSuccessTimer = null
      }
      this.dialog_cancel_success = false
      if (this.openBookings && this.openBookings.length) {
        this.stepper = 30
      } else {
        this.$emit('change-tab', this.$parent.tabItems ? this.$parent.tabItems.indexOf('Info') : 0)
      }
    },

    resetForm(st,stepper)
    {
      console.log(2402,st,stepper)
      if (!this.successfulBooking)
      {
        switch(st)
        {
          case 1:
            Object.assign(this.booking, {date: null, covers: null,children: 0,  locationId: null, mealId:null, slotId:null, time:null,waitingListTime:null})
          break;
          case 2:
            Object.assign(this.booking, {date: null, covers: null,children: 0,  locationId: null, mealId:null, slotId:null, time:null,waitingListTime:null})
          break;
          case 3:
            Object.assign(this.booking, {covers: null,children: 0,locationId: null, mealId:null, slotId:null, time:null,waitingListTime:null})
            this.childrenQuestion = null  // reset highchair question
          break;
          case 4:
            Object.assign(this.booking, {locationId: null, mealId:null, slotId:null, time:null,waitingListTime:null})
            
          break;
          case 5:
            Object.assign(this.booking, { mealId:null, time:null,waitingListTime:null})
          break;
          case 12:
            
          break
          default:
            //Object.assign(this.booking, { mealId:null, slotId:null, time:null,waitingListTime:null})
        }
        if(this.locations.length===1)
        {
          this.booking.locationId=this.locations[0].locationId;
        }
        console.log(2414,this.booking)
      }
    },
    handleCoversChange(value) {
      // Check if the "more than" button (value 13) was clicked
      const maxCovers = this.settings.options.maxBookableCovers/1;
      if (value === maxCovers + 1) {
        // Unset the selection
        this.$nextTick(() => {
          this.booking.covers = null;
        });
        // Open the dialog
        this.dialog_more_than = true;
      } 
      else
      {
        console.log(2072,this.booking.children)// Normal cover selection, proceed as usual
        if(this.booking.children!==null&&this.booking.covers)
        {
          console.log(2124,'Goto 6')
          this.changeStepper(3, null);
        }
      }
    },
    /**
     * Called when user picks a different location in step 6.
     * Re-fetches slots WITHOUT hiding the slot list during the refresh.
     */
    changeLocation(newValue) {
      if (newValue !== undefined && newValue !== null) {
        this.booking.locationId = newValue;
        const aMeals = this.activeMeals();
        if (aMeals && aMeals.length) {
          this.booking.mealId = aMeals[0].mealId;
        }
        console.log(1792,this.booking, this.booking.locationId)
        // Clear the previously selected slot (it belonged to the old location)
        this.booking.slotId = null;
        this.booking.time = null;
        // Re-fetch keeping tryToGetFreeSlots=true so the list stays visible
        this.getFreeSlots();
      }
    },
    changeStepper(current,data=null)
    {
      var nStepper=null;
      var aMeals=this.activeMeals();
      switch (current)
      {
        case 1:
          nStepper=2;
        break;
        case 2:
          nStepper=3;
        break;
        case 3:
          console.log(1622,this.locations.filter(x=> (this.booking.date>=x.dateFrom&&this.booking.date<=x.dateTo)||!this.booking.date).length)
          // activeLocations computed inline below
          nStepper=this.booking.covers&&this.booking.children!=null?4:3;
          
          nStepper=6; //get free slots
          //this.booking.locationId=this.locations[0].locationId;
          this.booking.mealId=aMeals[0].mealId;
          console.log(1639,this.locations.length)
          //this.freeTables='wait';
          //this.tryToGetFreeSlots=true;
          if (this.locations.length===1)
          {
            //this.booking.locationId=this.locations[0].locationId;
            this.tryToGetFreeSlots=true;
            this.getFreeSlots();
          }
          //this.getFreeSlots(this.booking);
/*
          if(activeLocations.length>1)
          {
            nStepper=4;   //select location
          }
          else
          {
            this.booking.locationId=this.locations[0].locationId;
            console.log(1629,aMeals,this.locations)
            if (aMeals.length>1)
            {
              nStepper=5; //select meal
            }
            else
            {
              nStepper=6; //get free slots
              this.booking.locationId=this.locations[0].locationId;
              this.booking.mealId=aMeals[0].mealId;
              console.log(1639)
              this.getFreeSlots(this.booking);
            }
            console.log(1643,nStepper,this.booking.locationId,this.booking.mealId, this.booking)
          }
*/
        break;
        case 4:
            //var aMeals=this.activeMeals();
            console.log(1649,aMeals)
            if (aMeals.length>1)
            {
              nStepper=5; //select meal
            }
            else
            {
              console.log(1655)
              this.booking.mealId=aMeals[0].mealId;
              this.getFreeSlots(this.booking);
              nStepper=6; //get free slots
            }
            console.log(1660,this.booking)
        break;
        case 5:
          console.log(1663,aMeals,this.locations)
          this.getFreeSlots(this.booking);
          nStepper=6;
        break;
        case 6:

        break;
        case 7:

        break;
        case 8:

        break;
        case 9:

        break;
        case 10:
          //this.checkIfDuplicateBooking()
          nStepper=data
        break;
        case 11:

        break;
        case 12:

        break;
        case 13:

        break;
        case 14:

        break;
        case 15:

        break;
        case 16:

        break;
        case 17:

        break;
        case 18:

        break;
        case 19:

        break;
        case 20:

        break;
        default:

      }
      this.stepper=nStepper;
    },   

    async changeNumber(bookingId,phoneChanged,countryCode)
    {
      this.loading_resend=true;
      this.checkResendWA=1
      const csrf = sessionStorage.getItem('csrf');
      const payload=JSON.stringify({"action":"booking_wrongNumber","payload":{"bookingId":bookingId,"phone":phoneChanged,"countryCode":countryCode,"customerId":this.customer.customerId},"csrf":csrf});
      console.log(2355,payload);
      
      this.changeStepper(10,14)
      const res = await this.$http.post('/booking/booking_stepper.php', payload );
      //console.log(1026,res);
      console.log('ChangeNumber',res)
      
      this.loading_resend=false;
      this.loading_optOut=false;
      switch (res.data.errorid)
      {
        case '0': {
          // Update CSRF token from header
          const csrfChange = res.headers['x-csrf-token'];
          if (csrfChange) {
            sessionStorage.setItem('csrf', csrfChange);
          }
          /*
          this.snackbar.text=this.$t(this.page+'.'+res.data.message);
          this.snackbar.color='success';
          this.snackbar.active=true;
          this.resendMessageEnabled=false
          */
          this.checkingWADelivered=1
          setTimeout(() => {
              this.changeStepper(10,13)
              this.checkWADelivered(this.bookingId_WA)
            }, 5000);

          this.attempts_WA++;
          break;
        }
        case '0006':
          this.$router.push('/unknown').catch(() => {});
        break;        
      }
    },    

    phoneMask(countryCode) {
      if (!this.mobilePhoneRegex) return '### ### ## ##';
      const dtls = this.mobilePhoneRegex.find(m => m.countryCode == countryCode);
      const len = dtls ? (dtls.maxLength || 10) : 10;
      const masks = { 8: '### ### ##', 9: '### ### ###', 10: '### ### ## ##', 11: '### ### ### ##' };
      return masks[len] || '### ### ## ##';
    },
    phoneRegexHints(countryCode)
    {
      //console.log(2460,countryCode)
      var output='';
      if (countryCode && this.mobilePhoneRegex)
      {
        output='Check twice the number: if it is wrong we have no way to contact you';
        var dtls=this.mobilePhoneRegex.find(m=>m.countryCode==countryCode)
        
        if (dtls)
        {
          var prefix = dtls.startsWith;
          var xCount = dtls.minLength - prefix.length;
          var qCount = dtls.maxLength - dtls.minLength;
          var raw = prefix + 'X'.repeat(xCount > 0 ? xCount : 0) + '?'.repeat(qCount > 0 ? qCount : 0);
          output = raw.match(/.{1,3}/g).join(' ');
        }
      }
      return output;
    },
    is_ValidPhone(v,r) {
            //var p='^324[0-9]{6}$'
            //var p='^6[6|9|7|5|8|9][0-9]{6,7}$'
            if (v)
            {
              const cleanV = String(v).replace(/\s/g, '')
              const vr=this.mobilePhoneRegex.find(c=>c.countryCode==r)?this.mobilePhoneRegex.find(c=>c.countryCode==r).mobileNumberRegex:null
              const p=vr?vr.replace('\\d','[0-9]'):''
              const pattern = new RegExp(p);
              //return pattern.test(v) || (r==39?'Ricontrolla: il formato sembra non corretto':'Please, check: this seems an invalid number')
              const ww= pattern.test(cleanV) || this.phoneRegexHints(r)
              //console.log(2335,ww)
              return ww;
            }
            else
            {
              return false;
            }
          },
    activeMeals()
    {
      var currentDate=this.bookableDays&&this.bookableDays.find(d=>d.date==this.booking.date)
      if (currentDate)
      {
        var aMeals=this.meals.filter(m=>(m.meal==='lunch'||m.meal==='breakfast')&&currentDate.isLUNCH_OPEN||(m.meal==='dinner'||m.meal==='cocktail')&&currentDate.isDINNER_OPEN)
        //console.log(2662,aMeals,currentDate);
        return aMeals;
      }
      else
      {
        console.log(2668,currentDate)
        var aaMeals=[];
        return aaMeals;
      }
    },

    /**
     * Create Stripe Payment Element in popup/dialog (EXACTLY like PayPal)
     * Payment form renders inside dialog - stays on same page
     * Includes Google Pay/Apple Pay wallet support
     */
    async createStripeCheckout() {
      const isTestMode = this.settings.options && this.settings.options.stripeTestMode == '1';
      const publishableKey = isTestMode
        ? (this.settings.options && this.settings.options.stripePublishableKeyTest)
        : (this.settings.options && this.settings.options.stripePublishableKeyLive);

      console.log('🔵 STRIPE [1] createStripeCheckout START', {
        prepaidAmount: this.booking.prepaidAmount,
        isTestMode,
        publishableKey: publishableKey ? publishableKey.substring(0, 20) + '...' : '❌ MISSING',
      });

      // Validate publishable key BEFORE touching Stripe SDK or making any calls
      if (!publishableKey) {
        this.snackbar = { active: true, color: 'error', text: 'Stripe publishable key is missing in settings!' };
        return;
      }

      this.stripeLoading = true;
      this.dialog_stripe = false;
      this.stripeWalletAvailable = false;
      this.stripeError = false;
      this.stripePaymentData = null;

      try {
        // 1. Make server call FIRST — get clientSecret from backend
        const csrf = sessionStorage.getItem('csrf');
        const customerId = this.customer?.customerId || sessionStorage.getItem('customerId');

        const payload = {
          action: 'createPaymentIntent',
          csrf: csrf,
          payload: {
            customerId: customerId,
            amount: Math.round(this.booking.prepaidAmount * 100), // Convert to cents
            currency: 'eur',
            capture_method: (() => {
              const method = this.settings.options && this.settings.options.stripeCaptureMethod
              if (method === 'smart') {
                // smart: hold (manual) when SOON (≤ threshold) — can capture on no-show within 7-day window
                //        charge immediately (automatic) when FAR — Stripe auth only lasts 7 days
                return this.hoursUntilReservation <= (this.settings.options.stripeChargeHours / 1)
                  ? 'manual'
                  : 'automatic'
              }
              return method === 'manual' ? 'manual' : 'automatic'
            })(),
            request_extended_authorization: 'if_available',
            payment_method_types: (this.settings.options && this.settings.options.stripePaymentMethods)
              ? this.settings.options.stripePaymentMethods.split(',').map(s => s.trim()).filter(Boolean)
              : ['card'],
            stripeEnabled: this.settings.options.stripeEnabled,
            stripeTestMode: this.settings.options.stripeTestMode,
            //apiKey: this.settings.options.stripeTestMode==='1'?this.settings.options.stripeSecretKeyTest:this.settings.options.stripeSecretKeyLive,
            bookingData: {
              date: this.booking.date,
              covers: this.booking.covers,
              children: this.booking.children || null,
              time: this.booking.time,
              firstName: this.booking.firstName,
              lastName: this.booking.lastName,
              phone: this.booking.countryCode + this.booking.phone,
              email: this.booking.email,
              locationId: this.booking.locationId,
              slotId: this.booking.slotId,
              bookingId: this.booking.bookingId || null,
              userId:this.settings.userId,
              rawCaptureMethod: this.settings.options.stripeCaptureMethod
            }
          }
        };

        console.log('🔵 STRIPE [2] Calling /stripe/create-payment-intent.php ...',payload);
        const response = await this.$http.post('/stripe/create-payment-intent.php', payload);
        
        console.log('🔵 STRIPE [3] Payment Intent response:', {
          errorid: response.data.errorid,
          message: response.data.message,
          hasClientSecret: !!(response.data.payloads && response.data.payloads.clientSecret),
        });

        if (response.data.errorid !== '0') {
          throw new Error(response.data.message || 'Failed to create Payment Intent');
        }

        const clientSecret = response.data.payloads.clientSecret;
        const paymentIntentId = response.data.payloads.paymentIntentId;
        this.stripePaymentIntentId = paymentIntentId;
        this.stripeClientSecret = clientSecret;
        // Store extended-auth context for post-confirmation check
        this.stripeExtendedAuthRequested   = response.data.payloads.extendedAuthRequested  || false;
        this.stripeEventTimestamp           = response.data.payloads.eventTimestamp         || null;
        this.stripeApplicationFeeAmount     = response.data.payloads.applicationFeeAmount   || 0;
        this.stripeExtendedAuthFallbackActive = false;

        // 2. Load Stripe.js SDK dynamically (only if not yet loaded)
        if (!window.Stripe) {
          const script = document.createElement('script');
          script.src = 'https://js.stripe.com/v3/';
          script.async = true;
          document.head.appendChild(script);
          await new Promise((resolve, reject) => {
            script.onload = resolve;
            script.onerror = reject;
          });
        }

        // 3. Initialize Stripe with publishable key
        // Under Direct Charges the PI lives on the connected account — Stripe Elements
        // must be initialised with stripeAccount, otherwise the sessions API returns 400.
        const connectAccountId = this.settings.options && this.settings.options.stripeConnectAccountId;
        this.stripe = connectAccountId
          ? window.Stripe(publishableKey, { stripeAccount: connectAccountId })
          : window.Stripe(publishableKey);
        console.log('🔵 STRIPE [4] Stripe SDK initialised',this.stripe);

        // 4. Create Stripe Elements using the clientSecret from the server
        const elements = this.stripe.elements({
          clientSecret: clientSecret,
          appearance: { theme: 'stripe', variables: { colorPrimary: '#1976d2' } }
        });

        // 5. Try to enable Google Pay wallet button via Express Checkout Element (modern API)
        const expressCheckoutElement = elements.create('expressCheckout', {
          buttonType: { googlePay: 'plain' },
          paymentMethods: { applePay: 'never', amazonPay: 'never', link: 'never', klarna: 'never' }
        });

        expressCheckoutElement.on('confirm', async (event) => {
          this.stripeLoading = true;
          try {
            const { error, paymentIntent } = await this.stripe.confirmPayment({
              elements,
              clientSecret,
              confirmParams: {},
              redirect: 'if_required'
            });
            if (error) {
              this.handleStripeFailure(error);
            } else if (paymentIntent) {
              this.handleStripeSuccess(paymentIntent);
            }
          } catch (err) {
            this.handleStripeFailure(err);
          } finally {
            this.stripeLoading = false;
          }
        });

        // Express Checkout availability is signalled via the 'ready' event (no canMakePayment())
        expressCheckoutElement.on('ready', ({ availablePaymentMethods }) => {
          if (availablePaymentMethods && availablePaymentMethods.googlePay) {
            this.stripeWalletAvailable = true;
          } else {
            console.log('Google Pay not available');
          }
        });

        // Always store the element — it will only render if a wallet is available
        this._pendingWalletButton = expressCheckoutElement;

        // 6. Create standard Payment Element (card, SEPA, etc.)
        const paymentElement = elements.create('payment');

        // 7. Store references BEFORE opening dialog
        this.stripeElements = elements;
        this.stripePaymentElement = paymentElement;

        // 8. Open dialog so the stripe_div ref exists in DOM
        this.dialog_stripe = true;

        // 9. Wait for Vuetify dialog transition to complete
        await new Promise(resolve => setTimeout(resolve, 350));
        await this.$nextTick();

        // 10. Mount elements into DOM refs
        if (this.$refs.stripe_div) {
          paymentElement.mount(this.$refs.stripe_div);
          console.log('🔵 STRIPE Payment Element mounted ✅');
        } else {
          console.error('❌ stripe_div ref not found after dialog opened!');
        }
        if (this._pendingWalletButton && this.$refs.stripe_wallet_div) {
          this._pendingWalletButton.mount(this.$refs.stripe_wallet_div);
          this._pendingWalletButton = null;
        }

        this.stripeLoading = false;

      } catch (error) {
        console.error('Stripe initialization error:', error);
        this.snackbar = {
          active: true,
          color: 'error',
          text: error.message || this.$t(this.page + '.Connection error. Please try again.')
        };
        this.stripeLoading = false;
      }
    },
    
    /**
     * Confirm Stripe payment (EXACTLY like PayPal onApprove)
     * Called when user clicks "Pay" button in dialog (for card payments)
     * Wallet payments are handled automatically in paymentRequest.on('paymentmethod')
     */
    async confirmStripePayment() {
      if (this.stripeLoading) return; // prevent double-click
      this.stripeLoading = true;
      
      try {
        // Confirm payment with Stripe (like PayPal actions.order.capture)
        const { error, paymentIntent } = await this.stripe.confirmPayment({
          elements: this.stripeElements,
          confirmParams: {
            // Payment Element handles billing details internally
          },
          redirect: 'if_required' // Stay in dialog (no redirect)
        });
        console.log(2575,paymentIntent);
        if (error) {
          // payment_intent_unexpected_state = already succeeded/captured on a retry
          if (error.code === 'payment_intent_unexpected_state' && error.payment_intent) {
            const pi = error.payment_intent;
            console.log('PaymentIntent already in state:', pi.status, pi);
            if (pi.status === 'succeeded' || pi.status === 'requires_capture') {
              this.handleStripeSuccess(pi);
            } else if (pi.status === 'requires_action') {
              this.stepper = 22; // 3DS pending screen
              this.stripeLoading = false;
            } else {
              this.handleStripeFailure(error);
            }
          } else {
            // Payment FAILED (card declined, insufficient funds, etc.)
            this.handleStripeFailure(error);
          }
        } else if (paymentIntent) {
          // Payment SUCCEEDED or requires action
          if (paymentIntent.status === 'succeeded' || paymentIntent.status === 'requires_capture') {
            this.handleStripeSuccess(paymentIntent);
          } else if (paymentIntent.status === 'requires_action') {
            // 3D Secure handled automatically by Stripe Elements
            console.log('Payment requires additional action:', paymentIntent);
            this.stepper = 22;
            this.stripeLoading = false;
          } else {
            console.warn('Unknown payment status:', paymentIntent.status);
            this.stripeLoading = false;
          }
        }
        
      } catch (error) {
        // ERROR (network error, timeout, exception)
        this.handleStripeError(error);
      }
    },
    
    /**
     * Handle successful Stripe payment (step 23)
     */
    async handleStripeSuccess(paymentIntent) {
      console.log('Stripe payment succeeded!', paymentIntent);

      // ── Extended-authorization fallback ───────────────────────────────────
      // When the PI was created with request_extended_authorization, Stripe may
      // or may not grant an extended window. capture_before (Unix timestamp) is
      // set after the customer authorises, so this is the earliest point we can
      // check it. If the granted window doesn't reach the booking event we fall
      // back to automatic capture (cancel this PI, create a new one, re-show the
      // payment form so the customer is charged immediately instead).
      if (this.stripeExtendedAuthRequested && this.stripeEventTimestamp) {
        const captureBefore = paymentIntent.capture_before; // seconds
        const extAuthOk = captureBefore && (captureBefore > this.stripeEventTimestamp);
        console.log('🔵 STRIPE Extended-auth check', {
          captureBefore,
          eventTimestamp: this.stripeEventTimestamp,
          extAuthOk,
        });
        if (!extAuthOk) {
          console.warn('🟠 STRIPE Extended auth insufficient — falling back to automatic capture');
          await this.stripeExtendedAuthFallback(paymentIntent.id);
          return; // do NOT proceed with normal success flow
        }
      }
      //if(this.currentBooking && this.currentBooking.paymentAmount>0 && this.booking.prepaidAmount&& this.booking.prepaidAmount!=this.currentBooking.paymentAmount) 
      if(this.currentBooking && this.currentBooking.paymentAmount>0) 
      {
        var action=this.currentBooking.stripeStatus==='requires_capture'?'cancel':'refund';
        this.checkAndSettlePrepayment(action)
      }


      this.stripePaid = true;
      this.stripeError = false;
      this.stripeCancel = false;
      this.dialog_stripe = false; // Close the payment dialog
      this.stepper = 13; // Success screen

      // Store paymentIntentId on booking so saveBooking() can pass it to the SP
      // and so we can link after bookingId is returned
      this.booking.stripePaymentIntentId = paymentIntent.id;

      // Populate stripePaymentData for display in step 23
      const pm = paymentIntent.payment_method_details || {};
      const card = pm.card || {};
      const pmObj = typeof paymentIntent.payment_method === 'object' ? paymentIntent.payment_method : {};
      const cardDetails = card.brand ? card : (pmObj.card || {});
      this.stripePaymentData = {
        amount: parseFloat(this.booking.prepaidAmount),
        status: paymentIntent.status === 'requires_capture' ? 'authorized' : 'succeeded',
        cardBrand: cardDetails.brand ? cardDetails.brand.charAt(0).toUpperCase() + cardDetails.brand.slice(1) : '',
        cardLast4: cardDetails.last4 || ''
      };
      
      // Save payment record to DB — bookingId is null here (booking not yet saved).
      // The link is established after saveBooking() returns the new bookingId.
      // Phone may be empty at step 8 — use customer fallback.
      const phone = this.booking.phone
        ? (this.booking.countryCode + '' + String(this.booking.phone).replace(/\s/g,''))
        : (this.customer?.phone || null);

      // Save booking first — populates this.bookingId_WA
      await this.delay(3000);
      await this.saveBooking();
      console.log('Booking saved, now linking Stripe payment with bookingId:', this.settings);
      // Then link the Stripe payment with the bookingId returned by saveBooking()
      this.saveStripePayment({
        paymentIntentId:      paymentIntent.id,
        amount:               this.booking.prepaidAmount,
        bookingDate:          this.booking.date,
        lastName:             this.booking.lastName || null,
        customerId:           localStorage.getItem('customerId'),
        accountId:            this.settings.accountId,
        phone:                phone,
        bookingId:            this.bookingId_WA || null,
        status:               paymentIntent.status,
        captureMethod:        paymentIntent.capture_method || null,
        currency:             paymentIntent.currency || 'eur',
        applicationFeeAmount: this.stripeApplicationFeeAmount || 0,
        captureBefore:        paymentIntent.capture_before   || null
      }).catch(e => console.warn('Could not record payment:', e));

      this.stripeLoading = false;
    },
    
    /**
     * Handle failed Stripe payment (step 24)
     */
    handleStripeFailure(error) {
      console.error('Stripe payment failed:', error);

      this.stripeError = true;
      this.stripeCancel = false;
      this.stripePaid = false;
      this.dialog_stripe = false; // Close the payment dialog
      this.stepper = 20; // Payment failed screen

      // Populate stripePaymentData for display in step 24
      this.stripePaymentData = {
        errorMessage: error.message || this.$t(this.page + '.Payment failed'),
        errorCode: error.code || null
      };

      // Record the failure in the database (non-blocking — don't await)
      if (error.payment_intent || this.booking.stripePaymentIntentId) {
        const phone = this.booking.phone
          ? (this.booking.countryCode + '' + String(this.booking.phone).replace(/\s/g,''))
          : (this.customer?.phone || null);
        const failureData = {
          paymentIntentId: (error.payment_intent && error.payment_intent.id)
                           || this.booking.stripePaymentIntentId
                           || null,
          amount: this.booking.prepaidAmount,
          bookingDate: this.booking.date,
          lastName: this.booking.lastName || null,
          customerId: localStorage.getItem('customerId'),
          phone: phone,
          bookingId: this.bookingId_WA || null,
          status: 'failed',
          captureMethod: null,
          currency: 'eur',
          errorMessage: error.message || 'Payment failed',
          errorCode: error.code || null
        };
        this.saveStripePayment(failureData).catch(e =>
          console.warn('Could not record payment failure:', e)
        );
      }
      
      this.stripeLoading = false;
    },
    
    /**
     * Extended-authorization fallback.
     * Called when the PI was authorized with request_extended_authorization but
     * Stripe didn't grant a window long enough to reach the booking date.
     * Cancels the current PI and re-creates it with capture_method:'automatic'
     * (immediate charge), then re-mounts Stripe Elements so the customer can pay.
     */
    async stripeExtendedAuthFallback(cancelPiId) {
      this.stripeExtendedAuthFallbackActive = true;
      this.stripeLoading = true;
      this.dialog_stripe = true; // keep/re-open dialog

      try {
        const csrf = sessionStorage.getItem('csrf');
        const customerId = this.customer?.customerId || sessionStorage.getItem('customerId');

        const payload = {
          action: 'createPaymentIntent',
          csrf: csrf,
          payload: {
            customerId: customerId,
            amount: Math.round(this.booking.prepaidAmount * 100),
            currency: 'eur',
            capture_method: 'automatic', // forced — charge immediately
            payment_method_types: (this.settings.options && this.settings.options.stripePaymentMethods)
              ? this.settings.options.stripePaymentMethods.split(',').map(s => s.trim()).filter(Boolean)
              : ['card'],
            stripeEnabled: this.settings.options.stripeEnabled,
            stripeTestMode: this.settings.options.stripeTestMode,
            cancelPreviousPiId: cancelPiId, // server will void the old authorisation
            bookingData: {
              date: this.booking.date,
              covers: this.booking.covers,
              children: this.booking.children || null,
              time: this.booking.time,
              firstName: this.booking.firstName,
              lastName: this.booking.lastName,
              phone: this.booking.countryCode + this.booking.phone,
              email: this.booking.email,
              locationId: this.booking.locationId,
              slotId: this.booking.slotId,
              bookingId: this.booking.bookingId || null,
              userId: this.settings.userId
            }
          }
        };

        const response = await this.$http.post('/stripe/create-payment-intent.php', payload);

        if (response.data.errorid !== '0') {
          throw new Error(response.data.message || 'Failed to create fallback Payment Intent');
        }

        const clientSecret = response.data.payloads.clientSecret;
        this.stripePaymentIntentId = response.data.payloads.paymentIntentId;
        this.stripeClientSecret = clientSecret;
        // Fallback PI is always automatic — no further extended-auth checks needed
        this.stripeExtendedAuthRequested = false;
        this.stripeEventTimestamp = null;

        // Rebuild Elements with the new client secret
        const newElements = this.stripe.elements({
          clientSecret: clientSecret,
          appearance: { theme: 'stripe', variables: { colorPrimary: '#1976d2' } }
        });

        // Unmount the old payment element before remounting
        if (this.stripePaymentElement) {
          try { this.stripePaymentElement.unmount(); } catch (_) { /* ignore */ }
        }

        const newPaymentElement = newElements.create('payment');
        this.stripeElements = newElements;
        this.stripePaymentElement = newPaymentElement;

        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 350));
        await this.$nextTick();

        if (this.$refs.stripe_div) {
          newPaymentElement.mount(this.$refs.stripe_div);
          console.log('🔵 STRIPE Fallback Payment Element mounted ✅');
        }

        this.stripeLoading = false;

      } catch (err) {
        this.stripeExtendedAuthFallbackActive = false;
        this.handleStripeFailure(err);
      }
    },

    /**
     * Handle Stripe error (network/exception - step 25)
     */
    handleStripeError(error) {
      console.error('Stripe error:', error);
      
      this.stripeError = true;
      this.stripeCancel = false;
      this.stripePaid = false;
      this.dialog_stripe = true;
      this.stepper = 22; // Error screen
      
      this.snackbar = {
        active: true,
        color: 'error',
        text: error.message || this.$t(this.page + '.Connection error. Please try again.')
      };
      
      this.stripeLoading = false;
    },
    
    /**
     * Save Stripe payment to database.
     * Called after payment confirmation AND again after saveBooking() to link bookingId.
     * Does NOT trigger saveBooking() — the normal step 9→10→"Book Now" flow handles that.
     * Returns the paymentId from the DB (or null on error).
     */
    async saveStripePayment(data) {
      console.log('Saving Stripe payment:', data);
      try {
        const csrf = sessionStorage.getItem('csrf');
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'saveStripePayment',
          csrf: csrf,
          payload: data
        });

        // Rotate tokens
        const jwt = res.headers['authorization'];
        if (jwt) {
          sessionStorage.setItem('jwt', jwt);
          this.$http.defaults.headers.common['Authorization'] = jwt;
        }
        const csrfNew = res.headers['x-csrf-token'];
        if (csrfNew) sessionStorage.setItem('csrf', csrfNew);

        if (res.data.errorid === '0') {
          return res.data.payloads;
        } else {
          console.warn('saveStripePayment error:', res.data.errorid, res.data.message);
          return null;
        }
      } catch (error) {
        console.error('saveStripePayment exception:', error);
        return null;
      }
    },
    
    /**
     * Retry Stripe payment (remount form in dialog)
     */
    async retryStripeBtn() {
      // Clear old form content
      if (this.$refs.stripe_div) {
        this.$refs.stripe_div.innerHTML = '';
      }
      if (this.$refs.stripe_wallet_div) {
        this.$refs.stripe_wallet_div.innerHTML = '';
      }
      
      // Reset states but KEEP dialog open
      this.stripeError = false;
      this.stripeCancel = false;
      this.stripePaid = false;
      this.stripeWalletAvailable = false;
      this.stripeElements = null;
      this.stripePaymentElement = null;

      // If we still have a valid stripe instance + clientSecret, remount elements
      if (this.stripe && this.stripeClientSecret) {
        this.stripeLoading = true;
        try {
          const elements = this.stripe.elements({
            clientSecret: this.stripeClientSecret,
            appearance: { theme: 'stripe', variables: { colorPrimary: '#1976d2' } }
          });
          const paymentElement = elements.create('payment');
          await this.$nextTick();
          if (this.$refs.stripe_div) {
            paymentElement.mount(this.$refs.stripe_div);
          }
          this.stripeElements = elements;
          this.stripePaymentElement = paymentElement;
        } catch (e) {
          console.warn('Could not remount elements, reinitializing:', e);
          this.dialog_stripe = false;
          this.stripeLoading = false;
          await this.$nextTick();
          this.createStripeCheckout();
          return;
        }
        this.stripeLoading = false;
      } else {
        // No existing session - must create a new Payment Intent
        this.dialog_stripe = false;
        await this.$nextTick();
        this.createStripeCheckout();
      }
    },
    
    /**
     * Cancel Stripe payment (close dialog)
     */
    cancelStripe() {
      this.dialog_stripe = false;
      this.stripeError = false;
      this.stripeCancel = false;
      this.stripePaid = false;
      this.stripeLoading = false;
      this.stripeWalletAvailable = false;
      
      // Clear forms
      if (this.$refs.stripe_div) {
        this.$refs.stripe_div.innerHTML = '';
      }
      if (this.$refs.stripe_wallet_div) {
        this.$refs.stripe_wallet_div.innerHTML = '';
      }
    },

    /**
     * Retry Stripe payment from result screen (step 23/24) → go back to step 10
     */
    retryStripePayment() {
      this.stripeError = false;
      this.stripePaymentData = null;
      this.stepper = 10;
      // Give user a moment then re-open the form
      this.$nextTick(() => {
        this.retryStripeBtn();
      });
    },

    /**
     * Check Stripe Payment Intent status (used in step 25 - 3DS pending)
     */
    async checkStripePaymentStatus() {
      if (!this.stripe || !this.stripeClientSecret) {
        this.stripeError = true;
        return;
      }
      this.stripeLoading = true;
      try {
        const { paymentIntent, error } = await this.stripe.retrievePaymentIntent(this.stripeClientSecret);
        if (error) {
          this.handleStripeFailure(error);
          return;
        }
        if (paymentIntent.status === 'succeeded' || paymentIntent.status === 'requires_capture') {
          this.handleStripeSuccess(paymentIntent);
        } else if (paymentIntent.status === 'requires_payment_method') {
          this.handleStripeFailure({ message: this.$t(this.page + '.Payment failed'), code: paymentIntent.status });
        } else {
          // Still pending  stay on step 22
          this.stripeLoading = false;
        }
      } catch (e) {
        this.handleStripeError(e);
      }
    },

    /**
     * Called when user clicks Continue on step 9 (guest details).
     * Routes to payment first if required and not yet paid, otherwise to step 10 (consent).
     */
    async checkBooking() {
      if (!this.booking.bookingId) // is a new reservation
      {
        this.loading_book = true;
        const csrf = sessionStorage.getItem('csrf');
        const payload = {
          action: 'checkBooking',
          payload: JSON.parse(JSON.stringify({
            phone: String(this.booking.phone||'').replace(/\s/g,''),
            countryCode: this.booking.countryCode,
            postalCode: this.booking.postalCode,
            email: this.booking.email,
            birthdate: this.booking.birthdate,
            date: this.booking.date,
            slotId: this.booking.slotId,
            shiftId: this.booking.shiftId,
            otp: this.booking.otp ? String(this.booking.otp).replace(/-/g, '') : null,
            otpSent: this.otpSent,
            customerId: localStorage.getItem('customerId')
          })),
          csrf: csrf
        };
        const checkResponse = await this.updateDB(payload);
        this.loading_book = false;
        switch (checkResponse.errorid) {
          case '0':       
            if (checkResponse && checkResponse.payloads && checkResponse.payloads.openBookings) {
              this.existingBookings = checkResponse.payloads.openBookings;
              this.createdDate = this.existingBookings[0].createdDate;
              this.stepper = 11; // Duplicate warning
              return;
            }
            console.log(2912, 'this.customer.validated:',checkResponse.payloads)
            this.customer.validated = checkResponse.payloads.validated;
            if (this.customer.validated==1)
            {
              if (this.paymentRequired && !this.stripePaid) 
              {
                // Before showing Stripe payment, save booking as confirmed (without sending WA)
                // If payment fails just set active=0 to reservation
                this.stepper = 10; // Stripe payment step
              } 
              else
              {
                if(checkResponse.payloads.validated==1&&checkResponse.payloads.reservationCount>0)
                {
                  
                  this.saveBooking()
                }
                else
                {
                  this.stepper = 9; // Consent + submit step
                }
              }
            }
            else
            {
              this.snackbar = { active: true, color: 'error', width: '50%', text: this.$t(this.page + '.Wrong OTP: Please check and try again') };
            }
            break;
          case '0006':
            this.$router.push('/unknown').catch(() => {});
            return;
          case '0403':
            window.location.reload();
          break;
          default:
            this.snackbar = { active: true, color: 'error', width: '50%', text: checkResponse.message || this.$t(this.page + '.An error occurred. Please try again.') };
            return;
        }
      }
      else
      {
        if (this.paymentRequired && !this.stripePaid) 
        {
          // Before showing Stripe payment, save booking as confirmed (without sending WA)
          // If payment fails just set active=0 to reservation

          //this.saveBooking('saveBooking_2','forPayment')
          this.stepper = 10; // Stripe payment step
        } 
        else
        {
          if(this.customer.validated==1)
          {
            console.log(3631, this.booking.prepaidAmount, this.currentBooking, this.currentBooking.paymentAmount)
            if(!this.booking.prepaidAmount && this.currentBooking && this.currentBooking.paymentAmount>0)
            {
              if(this.currentBooking.stripeStatus=='requires_capture')
              {
                console.log(3636, 'Cancelling prepayment because booking amount changed to 0');
                this.checkAndSettlePrepayment('cancel') 
              }
              else
              {
                console.log(3641, 'Cancelling prepayment because booking amount changed to 0');
                this.checkAndSettlePrepayment('refund') 
              }
            }
            this.saveBooking()
          }
          else
          {
            this.stepper = 9; // Consent + submit step
          }
        }
      }
    },

    /**
     * Close Stripe result screen.
     * Success: auto-set optIn and silently call checkIfDuplicateBooking() (jumps to 11 if duplicate, else 12).
     * Failure: back to payment step 10.
     */
    closeStripeResult() {
      console.log('Closing Stripe result screen. Payment success:', this.stripePaid);
      if (this.stripePaid) {
        // Payment done — GDPR implicitly accepted (they paid), skip consent step 9 entirely
        this.booking.optIn = true;
        this.stepper = 13; // Processing spinner
        //this.saveBooking();
      } else {
        // Payment failed/cancelled: back to Stripe payment step
        this.stripePaymentData = null;
        this.stripeError = false;
        this.stepper = 10;
      }
    },

    /**
     * Helper: go to next step after slot selection
     * (requests if present, else guest details first, then payment)
     */
    goToNextAfterSlot() {
      console.log(3610,this.booking, this.booking.locationId)
      if (this.booking.locationId)
      {
        if (this.booking.slotId) {
          // Edit mode: if slot needs manual confirmation, show diff screen first
          if (this.forceManualConfirmation) {
            this.stepper = 8;
            return;
          }
          const hasRequests = (this.requests && this.requests.length) || (this.foodStyles && this.foodStyles.length);
          if (hasRequests) {
            this.stepper = 7;
          } else {
            // Always collect guest details first (step 8), payment comes after
            this.stepper = 8;
          }
        }
      }
      else
      {
          this.snackbar.text=this.$t(this.page+'.You have not selected the Area');
          this.snackbar.color='warning';
          this.snackbar.active=true;
          this.stepper = 6;
      }
    },
    saveBirthdate (date) {
      this.$refs.menuBirthdate.save(date)
    },    
    subtractYears(years) {
      var date = new Date(Date.now())
      date.setFullYear(date.getFullYear() - years);
      return date.toISOString().substring(0, 10);
    },    
    async optOut()
    {
      this.loading_optOut=true;
      //console.log(2216,this.customerId);
      this.customerId=localStorage.getItem('customerId')
      const csrf = sessionStorage.getItem('csrf');
      const payload=JSON.stringify({"action":"optOut","payload":{"customerId":this.customerId},"csrf":csrf});
      const res = await this.$http.post('/booking/booking_stepper.php', payload );
      console.log('OptOut',res)
      //console.log(1026,res);
      this.loading_optOut=false;
      switch (res.data.errorid)
      {
        case '0': {
          // Update CSRF token from header
          const csrf2 = res.headers['x-csrf-token'];
          if (csrf2) {
            sessionStorage.setItem('csrf', csrf2);
          }
          localStorage.removeItem('customerId');
          this.snackbar.text=this.$t(this.page+'.'+res.data.message);
          this.snackbar.color='success';
          this.snackbar.active=true;
          await this.delay(1000);
          //console.log(2373)
          this.Authenticate();
          //console.log(2375);
          break;
        }
        case '0006':
          this.$router.push('/unknown').catch(() => {});
        break;        
      }
    },
    delay(milliseconds){
        return new Promise(resolve => {
            setTimeout(resolve, milliseconds);
        });
    },     
    /**
     * Send WhatsApp OTP to verify phone number
     */
    async sendOtpWA() {
      if (this.otpSending || this.otpResendCooldown > 0) return
      if (this.stepper !== 8) return
      if (this.is_ValidPhone(this.booking.phone, this.booking.countryCode) !== true) return
      this.otpSending = true
      try {
        const csrf = sessionStorage.getItem('csrf')
        const payload = {
          action: 'sendOtp',
          csrf,
          payload: {
            phone: String(this.booking.phone||'').replace(/\s/g,''),
            countryCode: this.booking.countryCode,
            customerId:localStorage.getItem('customerId'),
            action:'validate'
          }
        }
        const rsp = await this.updateDB(payload)
        if (rsp && rsp.errorid === '0') {
          this.otpSent = true
          this.otpError = false
          this.otp = null
          this.otpResendCount++
          // After 2 resends, show WhatsApp privacy policy dialog
          if (this.otpResendCount >= 2) {
            setTimeout(() => {
              this.otpPrivacyDialog = true;
            }, 5000);
          }
          // Start 30s cooldown for resend button
          this.otpResendCooldown = 30
          if (this._otpCooldownTimer) clearInterval(this._otpCooldownTimer)
          this._otpCooldownTimer = setInterval(() => {
            if (--this.otpResendCooldown <= 0) {
              clearInterval(this._otpCooldownTimer)
              this._otpCooldownTimer = null
            }
          }, 1000)
        }
      } catch (e) {
        console.error('sendOtpWA error', e)
      } finally {
        this.otpSending = false
      }
    },

    async getFreeSlots()
    {
      //console.log(3290,'this.booking',this.booking,'currentBooking',this.currentBooking)
      var totCurrentBooking=this.currentBooking&&this.currentBooking.covers+this.currentBooking.children;
      var totBooking=this.booking&&this.booking.covers+this.booking.children;
      this.isCoverChanged=totBooking-totCurrentBooking
      //console.log(3293,'totCurrentBooking',totCurrentBooking,'totBooking',totBooking)

      this.dialog_connectionError=false;
      // Only hide the slot list (show spinner) when there are no slots yet.
      // When re-fetching after a location change, keep existing slots visible.
      if (!this.freeTables || !this.freeTables.length) {
        this.tryToGetFreeSlots=false;
        console.log(4341,'azzera this.tryToGetFreeSlots',this.tryToGetFreeSlots) 
      }

      if(this.booking.covers&&this.booking.date)
      { 
        try{
          this.authenticated=1;
          ////console.log(1109,this.booking.date);
          /*
          if(this.booking.locationId===null){
            this.booking.locationId=this.locations[0].locationId;
          }
          */
          //let booking=this.currentBooking?{...this.currentBooking}:{...this.booking};
          let booking={...this.booking};
          delete booking.requests;
          delete booking.foodStyles
          ////console.log(1112,this.booking);
          if(booking.locationId===null){
            booking.locationId=this.locations[0].locationId;
          }
          booking.reassign=0;
          booking.requester='db';
          //booking.locationId=this.booking.locationId||(this.currentBooking&&this.currentBooking.locationId)||null
          this.loading=true;

            const csrf = sessionStorage.getItem('csrf');
            const payload={"payload": booking,"action":"freeTables_map_get","csrf":csrf};
            const res = await this.$http.post('/booking/booking_stepper.php', payload );
            //console.log(1811,res, new Date());
            this.loading= false;
            switch (res.data.errorid)
            {
              case '0': {
                  
                  const jwt4 = res.headers['authorization'] || res.data.jwt;
                  if (jwt4) {
                    sessionStorage.setItem('jwt', jwt4);
                    this.$http.defaults.headers.common['Authorization'] = jwt4;
                  }
                  // Update CSRF token from header
                  const csrf4 = res.headers['x-csrf-token'];
                  if (csrf4) {
                    sessionStorage.setItem('csrf', csrf4);
                  }
                  this.freeTables=res.data.payloads.freeTables;
                  this.forceTableAllocation=res.data.payloads.forceTableAllocation;
                  //this.allRules=res.data.payloads.allRules;
                  //console.log(2061,this.freeTables,this.allRules)
                  this.tryToGetFreeSlots=true;
                  console.log(4390,this.tryToGetFreeSlots)
                  return true;
              }
              case '0003':
                  this.freeTables=[];
                  this.tryToGetFreeSlots=true;
                  this.snackbar.text=res.data.message;
                  this.snackbar.color='warning';
                  this.snackbar.active=true;
              break;
              case '0007':
                var responsePayload=JSON.parse(res.data.payload)
                this.errorTitle=responsePayload.errorInfo[2];
                this.errorMessage=responsePayload.xdebug_message;
                //console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
                this.dialog_connectionError=true;
              break;
              case '0403':
                  //this.$router.push('/auth/login').catch(() => {});
                  window.location.reload();
              break;
            }  
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }
      }
      else
      {
        console.log(3061,this.booking)
        this.freeTables=[];
      }
    },

    async saveBooking(action = 'saveBooking',option =''){
      const slot = this.freeTables.find(ft => ft.slotId === this.booking.slotId)
      console.log(3105, 'saveBooking', { action, option, slot })
      console.log(3106, 'saveBooking', slot.manualConfirmation)
      //this.disableStepperHeader = true
      // Build the payload — shallow-clone booking and enrich with runtime values
      const booking = {
        ...this.booking,
        phone:                String(this.booking.phone||'').replace(/\s/g,''),
        isCoverChanged:       this.isCoverChanged,
        //isforPayment:         option === 'forPayment' ? 0 : 1,
        sendWAConfirmation:   this.settings.options.WA_sendBookingConfirmation, //WA_sendBookingConfirmation
        notCompliant:         slot.notCompliant,
        manualConfirmation:   slot.manualConfirmation , // edit on waitlisted slot → restaurant must approve
        customerId:           localStorage.getItem('customerId'),
        //WAVerification:       this.voxNumber || this.booking.bookingId || this.customer.WAVerification ? 1 : 0,
        validated:            this.voxNumber || this.booking.bookingId || this.customer.validated  ? 1 : 0,
        //WAConfirmed:          this.voxNumber || this.booking.bookingId || this.customer.WAConfirmed     ? 1 : 0,
        volante:              0,
        locale:               this.settings.locale,
        waitingListTime:      this.booking.waiting ? 1 : null,
        stripeSessionId:      this.booking.stripePaymentIntentId || null,
        paymentAmount:         this.booking.prepaidAmount || null,
        devNumber:             localStorage.getItem('devNumber') || null,
        //manualConfirmation:   this.forceManualConfirmation ? 1 : 0, // edit on waitlisted slot → restaurant must approve

      }

      // Attach table allocation when the server forces it
      if (this.forceTableAllocation) {
        booking.tables   = slot.newBookingTables
        booking.tablesId = slot.newBookingTablesId
        booking.manual   = 1
      }

      this.loading_book         = true
      this.open_confirm_dialog  = true

      const csrf = sessionStorage.getItem('csrf')
      const w    = await this.updateDB({ action, payload: booking, csrf })
      console.log('SaveBooking_3100', w,booking)

      this.loading      = false
      this.loading_book = false

      if (w && w.errorid === '0' && w.bookingId) {
        this.bookingRslt         = w.rslt
        this.bookingId_WA        = w.bookingId
        this.phone               = this.booking.phone
        this.successfulBooking   = true
        this.checkingWADelivered = 1
        //console.log(3176,w.json.statusId)
        this.url=window.location.host; 
        //if (!this.paymentRequired)
          //this.changeStepper(10, 13)
        switch(w.json.statusId)
        {
          case 'unconfirmed':
            this.changeStepper(10, (this.forceManualConfirmation && this.currentBooking) ? 19 : 15)
          break;
          case 'listed':
            console.log(3150,w.json.statusId)
            this.changeStepper(10, (this.forceManualConfirmation && this.currentBooking) ? 19 : 16)
          break;
          case 'confirmed':
              if(this.currentBooking)
              {
                 this.changeStepper(10, this.forceManualConfirmation ? 19 : 17)
              }
              else
              {
                this.changeStepper(10,18)
              }
          break;

        }

        /*
        // Link Stripe payment record to the new bookingId (non-blocking)
        if (this.stripePaid && this.booking.stripePaymentIntentId) {
          this.saveStripePayment({
            paymentIntentId: this.booking.stripePaymentIntentId,
            bookingId:       this.bookingId_WA,
            amount:          this.booking.prepaidAmount,
            bookingDate:     this.booking.date,
            customerId:      this.customerId,
            status:          'succeeded'
          }).catch(e => console.warn('Could not link Stripe payment to booking:', e))
        }
        */
        //setTimeout(() => this.checkWADelivered(this.bookingId_WA), 5000)
      }
    },

    async updateDB(payload)
    {
      try{
          const res = await this.$http.post('/booking/booking_stepper.php', payload);
          //console.log(1284,res);
          if (res.data.errorid=='0')
          {
            const jwt6 = res.headers['authorization'] || res.data.jwt;
            if (jwt6) {
              sessionStorage.setItem('jwt', jwt6);
              this.$http.defaults.headers.common['Authorization'] = jwt6;
            }
            // Update CSRF token from header
            const csrf = res.headers['x-csrf-token'];
            if (csrf) {
              sessionStorage.setItem('csrf', csrf);
            }
          }
          else
          {
            //console.log(1291);
            //this.$router.push('/auth/login').catch(() => {});
          }
          return res.data;
      } catch(e)
      {
        this.dialog_connection_error=true;
        //console.log(e);
      }
    },
    allowedDates(val) {
        if (this.settings?.options?.disableClosedDays === '0') {
          return true;
        }
        const day = this.bookableDays.find(d => d.date === val);
        return Boolean(day && day.isDAY_OPEN);
      }, 
      handleDateClick(date) {
        console.log(4399,date,this.disableSameDayDirectBooking)
          // Check if the clicked date matches the same-day restriction
          if (this.disableSameDayDirectBooking && date === this.disableSameDayDirectBooking) {
            // Show your dialog
            this.showSameDayDialog = true;

            // Optional: Reset booking date if you don't want it selected
            this.booking.date = null;
            return; 
          }

          // If it's a normal date, proceed to Step 2
          this.changeStepper(2, null);
        },         
    allowedDates_old(val)
    {
      ////console.log(1231,val)
      var r= this.bookableDays.find(d=>d.date==val)&&this.bookableDays.find(d=>d.date==val&&d.isDAY_OPEN)||this.settings.options.disableClosedDays=='0'?val:null;
      ////console.log(1233,r)
      return r
    },
    reset()
    {
      /*this.booking={...this.booking_clone};
      this.tryToGetFreeSlots=false;
      //console.log(2358,this.booking);
      this.booking.requests=JSON.parse(this.requestsCopy);
      this.booking.foodStyles=JSON.parse(this.foodStylesCopy);*/
      this.stripePaid=false;
      this.stripePaymentData=null;
      this.stripeSessionId=null;
      this.dialog_booked = false;
    },
    b64E(str)
    {
      return btoa(encodeURIComponent(str));
    },
   /**
     * Show error message in snackbar
     */
    showError(message) {
      this.snackbar = {
        active: true,
        color: 'error',
        text: message
      }
    },

    /**
     * Show success message in snackbar
     */
    showSuccess(message) {
      this.snackbar = {
        active: true,
        color: 'success',
        text: message
      }
    },
    getOS() {
          // Modern browsers (User Agent Client Hints)
          if (navigator.userAgentData && navigator.userAgentData.platform) {
            return navigator.userAgentData.platform
          }

          // Fallback for older browsers
          const userAgent = window.navigator.userAgent.toLowerCase()
          if (userAgent.indexOf('win') !== -1) return 'Windows'
          if (userAgent.indexOf('mac') !== -1) return 'macOS'
          if (userAgent.indexOf('android') !== -1) return 'Android'
          if (userAgent.indexOf('like mac') !== -1 || userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) return 'iOS'
          if (userAgent.indexOf('linux') !== -1) return 'Linux'

          return 'Unknown OS'
        },

        // 2. Gather Device Info
        getDeviceInfo() {
          return {
            os: this.getOS(),
            screen: {
              // Hardware monitor resolution
              screenWidth: window.screen.width,
              screenHeight: window.screen.height,
              // Active browser viewport size
              viewportWidth: window.innerWidth,
              viewportHeight: window.innerHeight,
              // Vuetify 2 reactive breakpoint (xs, sm, md, lg, xl)
              breakpoint: this.$vuetify.breakpoint.name
            },
            // Optional: track if launched as installed PWA standalone app
            isPWA: window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
          }
        },    
    async openAdvertiser(item) {
      if (!item || !item.url) return
      const base = /^https?:\/\//i.test(item.url) ? item.url : (window.location.origin + item.url)
      const u = new URL(base)
      if (item.fieldName) u.searchParams.set(item.fieldName, item.token)
      this.advertiserIframeUrl = u.toString()
      this.dialog_advertiser = true
      try {
        const deviceInfo = this.getDeviceInfo()
        await this.$http.post('/booking/booking_stepper.php', {
          action: 'advertiserClick',
          payload: {
            brand:         item.brand || item.logo || null,
            token:         item.token || null,
            url:           this.advertiserIframeUrl,
            locale:        this.settings.locale,
            screenWidth:   deviceInfo.screen.screenWidth,
            screenHeight:  deviceInfo.screen.screenHeight,
            viewportWidth: deviceInfo.screen.viewportWidth,
            viewportHeight:deviceInfo.screen.viewportHeight,
            OS:            deviceInfo.os,
            customerId:    this.customer.customerId,
            accountId:     this.settings.accountId,
          }

        })
      } catch (e) { console.error('Failed to log advertiser click', e) }
    },         
  }
}

</script>


<style>
hr.fw {
  min-width: 100%;
  margin:0!important;
} 
.v-stepper__step__step{
  display:none;
}
.v-stepper__label{
  display: block !important
}
.v-stepper__step{
  flex-basis: 75px !important;
}
.v-divider {
  max-width:100%!important;
  margin-top: 24px!important
}
.v-stepper__step{
  padding: 6px 24px
}
.v-stepper__label{
  height:46px;
}
.text-slotid-top{
  font-size:0.60rem !important;
}
.text-slotid-availability{
  font-size:0.65rem !important;
  padding: 3px 8px;
  margin-top: 6px;
  border-radius: 15px;
}
</style>
<style scoped>
/* Flat cards with a subtle light border instead of shadow */
.v-card {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.v-card:not(.v-card--flat) {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 6px !important;
}
.v-btn:before {
  background-color: unset !important;
}
.transparent-bg {
  background: transparent !important;
}
.slot-btn {
  border-color: rgba(0,0,0,0.12) !important;
}

/* Slot list reveal animation */
.slot-reveal-enter-active {
  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.slot-reveal-leave-active {
  transition: opacity 0.2s ease-in,
              transform 0.2s ease-in;
}
.slot-reveal-enter {
  opacity: 0;
  transform: translateY(18px);
}
.slot-reveal-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>  

<style>
.custom-sq-picker{border:#fff!important}
 /* Use !important to override Vuetify's inline styles */
.v-application .custom-sq-picker .v-date-picker-table td {
  padding: 2px !important; /* Increase this number for more gap */
}  
  
.v-application .custom-sq-picker .v-date-picker-table .v-btn {
  border-radius: 4px !important;
  width: 100% !important;
  font-size: 1.1rem !important;
  border: 1px solid #e0e0e0 !important;
  background:transparent!important;
  box-shadow: none !important; /* Remove the button shadow */
  padding: 20px 0 !important; /* Add padding to make the button fit the cell */
}

/* For disabled days */
.v-application .custom-sq-picker .v-date-picker-table .v-btn--disabled {
  background-color: #f5f5f5 !important;
  border-color: #eeeeee !important;
}

/* For the active/selected day */
.v-application .custom-sq-picker .v-date-picker-table .v-btn--active {
  border: 2px solid #1976D2 !important;
  background-color: transparent !important;
  color: #1976D2 !important;
}
/* Amber override when selected date = original booking date */
.v-application .custom-sq-picker.booking-date-amber .v-date-picker-table .v-btn--active {
  border: 2px solid #FFB300 !important;
  background-color: transparent !important;
  color: #FFB300 !important;
}
</style>
<style scoped>
/* Target Vuetify's inner container to allow multi-line wrapping */
.btn-multiline >>> .v-btn__content {
  width: 100%;
  white-space: normal;
}
</style>

<style scoped>
/* 1. CURRENT DAY (Grey background, bold text) */
.custom-sq-picker ::v-deep .v-btn.v-date-picker-table__current {
  background-color: #d6dbed !important; 
  border-color: #d6dbed !important;     
}
.custom-sq-picker ::v-deep .v-btn.v-date-picker-table__current .v-btn__content {
  font-weight: bold !important;
  color: #212121 !important; /* Dark text for readability on grey */
}

/* 2. SELECTED DAY (Black background, white text) */
/* Targets the active button state inside the picker table */
.custom-sq-picker ::v-deep .v-date-picker-table .v-btn--active {
  background-color: #000000 !important;
  border-color: #000000 !important;
}
.custom-sq-picker ::v-deep .v-date-picker-table .v-btn--active .v-btn__content {
  color: #ffffff !important;
  font-weight: bold !important; /* Optional: keeps it prominent when selected */
}
</style>

<style scoped>
.section-label {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #333;
}

.tile-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.option-tile {
  position: relative;
  border: 1.5px solid #e0e0e0;
  border-radius: 12px;
  padding: 12px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: #fff;
}

.option-tile:active {
  transform: scale(0.96);
}

.option-tile--selected {
  background: #000;
  border-color: #000;
}

.option-tile--selected .option-tile__label {
  color: #fff;
}

.option-tile--prev:not(.option-tile--selected) {
  border-color: #ffc107;
  border-style: dashed;
}

.option-tile--disabled {
  opacity: 0.4;
  pointer-events: none;
}

.option-tile__icon {
  font-size: 22px;
}

.option-tile__label {
  font-size: 0.72rem;
  line-height: 1.15;
  color: #333;
}

.option-tile__check {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #42a5f5;
  border-radius: 50%;
  padding: 2px;
}
</style>

<style scoped>
.booking-card {
  border-radius: 16px !important;
  border-color: #e0e0e0 !important;
  overflow: hidden;
}

.booking-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
}

.booking-card__body {
  padding: 8px 14px;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 6px 0;
}

.booking-card__actions {
  display: flex;
  padding: 10px 14px;
}

.app-btn {
  border-radius: 10px !important;
}
</style>

<style scoped>
.clickable-slide {
  cursor: pointer;
}

.fullscreen-carousel-card {
  height: 100%;
  background: #000;
}

.fullscreen-carousel-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
}

.advertiser-iframe-card {
  height: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
}

.advertiser-iframe {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
}

.advertiser-iframe-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
}
</style>

<style scoped>
.v-application .custom-sq-picker.v-picker--date .v-picker__body {
  height: auto !important;
}

.v-application .custom-sq-picker .v-date-picker-table {
  height: auto !important;
  overflow: visible !important;
}

/* the table wraps rows in a transition-group container that is also
   absolutely positioned/height-locked in v2 - free it up too */
.v-application .custom-sq-picker .v-date-picker-table__table,
.v-application .custom-sq-picker .v-date-picker-table > div {
  position: static !important;
  height: auto !important;
}

/* each week row */
.v-application .custom-sq-picker .v-date-picker-table table tr {
  height: auto !important;
}
</style>